/* eslint-disable @typescript-eslint/camelcase */
import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import { CargoPresenter } from "../presenters/CargoPresenter";
import {
  CargoCommodityList,
  CargoData,
  CargoDetailStt,
  CargoEntities,
  CargoPieceDetail,
  CargoSttDetail,
  CargoSttList,
  CargoSttValidaton,
  CargoProductEntities,
  SearchCargoOptions,
  AirportEntities,
  AirportData,
  DimensionData,
  ListLastReadCargo,
  AirportDetail,
  CargoInputData,
  DestinationCityData,
  OriginCityData,
  CargoAddResponse,
  SearchFlight,
  DimensionPerKoliData,
  DimensionPerKoliDetail,
  FlightAvailable,
  CargoScanFailed,
  CargoStorageKey,
  CargoDetailBagData,
  CalculateVolume,
  CargoMinimumWeightSummaryData,
  CargoSummaryInProcessData,
  CargoSuccessSummaryData,
  CargoFailedUnread
} from "@/domain/entities/Cargo";
import {
  ReadyToCargo,
  ReadyToCargoListEntities,
  RequestCheckEligibleReadyToCargo
} from "@/domain/entities/ReadyToCargo";
import { Pagination } from "@/domain/entities/Pagination";
import {
  EditCargoApiRequest,
  EditCargoBagOrStt,
  AddBagOrSttNumberRequest,
  BagOrSttNumber,
  AddBagOrStt,
  AddCargoRequest,
  FlightPlanForECargo,
  CargoListRequest,
  UpdateRetryCargoRequest,
  DimensionPieces,
  SearchFlightRequest,
  CheckAvailableRequest,
  AwbValidationApiRequest,
  CalculateVolumeApiRequest,
  CalculateVolumeRequest,
  CargoMinimumWeightSummaryApiRequest,
  CargoSummaryInProcessRequest,
  DownloadCargoListApiRequest,
  FailedUnreadRequest,
  AirportRouteTypeApiRequest
} from "@/data/payload/api/CargoApiRequest";
import { ResponseBagSttDetail } from "@/domain/entities/ResponsePayload";
import {
  CargoDisputeSummaryData,
  AirportRouteTypeData
} from "@/domain/entities/Cargo";
import { MainAppController } from "./MainAppController";
import parsingErrorResponse from "@/app/infrastructures/misc/common-library/ParsingErrorResponse";
import {
  AwbDetailData,
  AwbTracking,
  FlightDetail
} from "@/domain/entities/NGen";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { dataLayer } from "@/app/infrastructures/misc/UtilsGtm";
import { NGenController } from "./NGenController";
import { gtmCargoData } from "../views/cargo/modules/gtm";
import { playNotification } from "@/app/infrastructures/misc/UtilsAudio";
import { app } from "@/main";
import { RegionBaggingGrouping } from "@/domain/entities/Bagging";
import { BaggingController } from "./BaggingController";
import firstCapitalize from "@/app/infrastructures/misc/common-library/FirstCapitalize";
import { ModalMessageEntities, OptionsClass } from "@/domain/entities/MainApp";
import router from "../router";
import { ReadyToCargoController } from "./ReadyToCargoController";
import groupBy from "lodash/groupBy";
import {
  getDataSessionStorage,
  storeDatatoSessionStorage
} from "@/app/infrastructures/misc/SessionStorage";
import { LocationController } from "./LocationController";
import uniqBy from "lodash/uniqBy";
import capitalize from "lodash/capitalize";
import { GTMBookingCargoEvent } from "@/app/infrastructures/misc/gtm-event/custom-events/booking-cargo-event";
import { getHubData } from "@/app/infrastructures/misc/Cookies";
import {
  cargoTypeData,
  getConfigDimensionDivider,
  getConfigIsminimumVolumePerPiece,
  SESSION_STORAGE_CARGO_KEY,
  CALCULATE_TYPE
} from "../views/cargo/modules/cargo-module";
import { flags } from "@/feature-flags";
import { FlagsPermissionCargo } from "@/feature-flags/flags-permission-cargo";
import { formatDate, formatByCountry, parseByCountry } from "@/app/infrastructures/misc/Utils";
import convertMinimumRounding from "@/app/infrastructures/misc/common-library/ConvertMinimumRounding";
import { formatInputNoDecimal } from "@/app/infrastructures/misc/common-library/FormatInputNoDecimal";
import { cloneDeep } from "lodash";
import { FlagsPermissionCargoV2 } from "@/feature-flags/flags-permission-cargo-v2";

interface CreateCargoParams {
  originAirportCode: string;
  destinationAirportCode: string;
  estTotalCargoGrossweigth: number;
  estTotalCargoVolumeweight: number;
  partnerName: string;
  partnerType: string;
  cargoNo: string;
  cargoVehicleNo: string;
  actualTotalCargoGrossweigth: number;
  actualTotalCargoVolumeweight: number;
  route: string;
  totalStt: number;
  totalPiece: number;
  cargoCommodity: string;
  productCargo: string;
  cargoType: string;
  originCityCode: string;
  destinationCityCode: string;
  departureDate: string;
  arrivalDate: string;
  bagOrStt: AddBagOrStt[];
  isCargoPlaneManual: boolean | null;
  cargoActualPiece: number;
  isFromRtc: boolean;
  rtcId: number;
  cargoOverCutoffLimit: boolean | null;
  cargoRtcTurnAuto: boolean | null;
  flightPlanForECargo?: FlightPlanForECargo[];
  dimensions?: DimensionPieces[];
  estDimension?: DimensionData;
  actualDimension?: DimensionData;
  nog?: string;
  rebookingId?: number;
  ngenCreatedAt?: string;
  shc?: string;
  isFromScheduleCard?: boolean;
  sequentialFlight?: number;
  totalFlight?: number;
  photoProof?: Array<string>;
  cargoTotalChargeableWeight?: number;
  cargoTotalCustomChargeableWeight?: number;
  cargoTotalEstimateChargeableWeight?: number;
  isNewCalculation?: boolean;
  calculateType?: string;
  isCargoDimensionOn?: boolean;
}

export interface CargoState {
  isLoading: boolean;
  isLoadingCargoProductList: boolean;
  cargoProductList: CargoProductEntities;
  cargoProductListError: boolean;
  cargoProductLisErrorCause: string;
  isLoadingAppend: boolean;
  modalSuccessAppend: boolean;
  isErrorAppend: boolean;
  errorCauseAppend: string;
  bagSttDetail: ResponseBagSttDetail;
  isCargoAvailable: boolean;
  isBookingAuto: boolean;
  isOverCutOffTime: boolean;
}

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "cargo-controller"
})
class CargoStore extends VuexModule implements CargoState {
  public isLoading = false;
  public isLoadingCargoProductList = false;
  public cargoProductList = new CargoProductEntities([]);
  public cargoProductListError = false;
  public cargoProductLisErrorCause = "";
  public isLoadingPrint = false;
  public isErrorPrint = false;
  public advanceFilterData = {
    type: { name: "", value: "" },
    cityOriginCode: "",
    cityDestinationCode: "",
    airport: ""
  };
  public cargoTypes: string[] = [];
  public isError = false;
  public errorCause = "";
  public isOpenModalTopup = false;
  public search = "";
  public pagination = {
    page: 1,
    limit: 10
  };
  public cargoData = new CargoEntities(new Pagination(1, 20), []);
  public retryCargo = new CargoEntities(new Pagination(1, 20), []);
  public airportData = new AirportEntities(new Pagination(1, 10), []);
  public airportDetail = new AirportDetail("", "");
  public airportDetailOrigin = new AirportDetail("", "");
  public airportDetailDestination = new AirportDetail("", "");
  public airportDataOrigin = new AirportEntities(new Pagination(1, 10), []);
  public airportDataDestination = new AirportEntities(
    new Pagination(1, 10),
    []
  );
  public isLoadingAirport = false;
  public periodeStart: any = null;
  public periodeEnd: any = null;
  public isFailed = false;
  public isOpenSuccess = false;
  public sttFailed: any[] = [];
  public cargoIdToGeneratePdf = "";
  public cargoIdToCancelOrDelete = 0;
  public cargoNoForModal = "";
  public cargoDetailData = new CargoData();
  public timestampBooking = 0;
  public showModalComplete = false;
  public showModalConfirm = false;
  public cargoInputForm: CargoInputData = JSON.parse(
    getDataSessionStorage("cargo-input-data") || "{}"
  );
  public cargoType = JSON.parse(getDataSessionStorage("cargo-type") || "{}");
  public showSelectAirportFromLocalStorage =
    (getDataSessionStorage("show-select-airport") == "true" ? true : false) ||
    false;

  public isChange = getDataSessionStorage("is-change-threshold-time") || false;
  public CargoInputData = new CargoInputData({
    id: this.cargoInputForm.id || 0,
    dimension: this.cargoInputForm.dimension || new DimensionData(),
    totalActualCargoGrossWeight:
      this.cargoInputForm.totalActualCargoGrossWeight || 0,
    totalActualCargoVolumeWeight:
      this.cargoInputForm.totalActualCargoVolumeWeight || 0,
    totalActualCargoColi: this.cargoInputForm.totalActualCargoColi || 0,
    destinationCityData: this.cargoInputForm.destinationCityData || "",
    originCityData: this.cargoInputForm.originCityData || {},
    nog: this.cargoInputForm.nog || "",
    cargoComodity: this.cargoInputForm.cargoComodity || "",
    cargoProduct: this.cargoInputForm.cargoProduct || "",
    vehicleNumber: this.cargoInputForm.vehicleNumber || "",
    cargoNumber: this.cargoInputForm.cargoNumber || "",
    airportOriginCode: this.cargoInputForm.airportOriginCode || "",
    airportDestinationCode: this.cargoInputForm.airportDestinationCode || "",
    estTotalCargoVolumeWeight:
      this.cargoInputForm.estTotalCargoVolumeWeight || 0,
    estTotalCargoGrossWeight: this.cargoInputForm.estTotalCargoGrossWeight || 0,
    estDepartureDate: this.cargoInputForm.estDepartureDate || new Date(),
    estArrivalDate: this.cargoInputForm.estArrivalDate || new Date(),
    airportOrigin:
      this.cargoInputForm.airportOrigin ||
      new AirportData("", "", "", "", "", "", "", ""),
    airportDestination:
      this.cargoInputForm.airportDestination ||
      new AirportData("", "", "", "", "", "", "", ""),
    thresholdTime: this.isChange
      ? this.cargoInputForm.thresholdTime
      : flags.cargo_config_flight_treshold_default_value.getValue(),
    isValidAwb: this.cargoInputForm.isValidAwb,
    isValidOriginOrDestination: this.cargoInputForm.isValidOriginOrDestination,
    awbTracking: this.cargoInputForm.awbTracking
  });
  public detailFlightsData: FlightDetail[] = JSON.parse(
    getDataSessionStorage("rtc-flights-data") || "[]"
  );
  public detailNextFlightsData: FlightDetail[] = JSON.parse(
    getDataSessionStorage("next-rtc-flights-data") || "[]"
  );
  public flowBooking: string = JSON.parse(
    getDataSessionStorage("flow-booking") || "{}"
  );
  public isDimensionChanged = false;

  // create
  public showCargoOptions = false;
  public cargoOptions: SearchCargoOptions = new SearchCargoOptions([]);
  form = {
    cargoType: this.cargoType.type || "",
    cargoTypeStatus: this.cargoType.status || "",
    originCityName: this.CargoInputData.originCityData.name,
    originCityCode: this.CargoInputData.originCityData.code,
    destinationCityName: this.CargoInputData.destinationCityData.name,
    destinationCityCode: this.CargoInputData.destinationCityData.code,
    estDepartureDate: this.CargoInputData.estDepartureDate,
    estArrivalDate: this.CargoInputData.estArrivalDate,
    nog: this.CargoInputData.nog,
    estTotalCargoGrossWeight: this.CargoInputData.estTotalCargoGrossWeight.toString(),
    estTotalCargoVolumeWeight: this.CargoInputData.estTotalCargoVolumeWeight.toString(),
    cargoCommodityName: this.CargoInputData.cargoComodity.name ?? "",
    cargoCommodityCode: this.CargoInputData.cargoComodity.code ?? "",
    cargoProduct: "",
    cargoNumber: this.CargoInputData.cargoNumber,
    vehicleNumber: this.CargoInputData.vehicleNumber,
    actualTotalCargoGrossWeight: this.CargoInputData.totalActualCargoGrossWeight.toString(),
    actualTotalCargoVolumeWeight: this.CargoInputData.totalActualCargoVolumeWeight.toString(),
    actualTotalSTTPieces: this.CargoInputData.totalActualCargoColi,
    sttList: [] as CargoDetailStt[],
    totalCargoVolumeWeight: 400,
    airportOrigin: {
      airportCode:
        this.detailFlightsData && this.detailFlightsData[0]?.Route != ""
          ? this.detailFlightsData[0]?.Route.split("-")[0]
          : this.CargoInputData.airportOriginCode != ""
          ? this.CargoInputData.airportOriginCode
          : this.CargoInputData.airportOrigin.airportCode ? this.CargoInputData.airportOrigin.airportCode : "",
      airportName: this.CargoInputData.airportOrigin.airportName,
      cityCode: this.CargoInputData.airportOrigin.cityCode,
      cityName: this.CargoInputData.airportOrigin.cityName,
      office: this.CargoInputData.airportOrigin.office,
      participantId: this.CargoInputData.airportOrigin.participantId,
      name: this.CargoInputData.airportOrigin.name,
      value:
        this.detailFlightsData && this.detailFlightsData[0]?.Route != ""
          ? this.detailFlightsData[0]?.Route.split("-")[0]
          : this.CargoInputData.airportOriginCode != ""
          ? this.CargoInputData.airportOriginCode
          : this.CargoInputData.airportOrigin.airportCode ? this.CargoInputData.airportOrigin.airportCode : ""
    },
    airportDestination: {
      airportCode:
        this.detailFlightsData &&
        this.detailFlightsData[this.detailFlightsData.length - 1]?.Route != ""
          ? this.detailFlightsData[
              this.detailFlightsData.length - 1
            ]?.Route.split("-")[1]
          : this.CargoInputData.airportDestinationCode != ""
          ? this.CargoInputData.airportDestinationCode
          : this.CargoInputData.airportDestination.airportCode ? this.CargoInputData.airportDestination.airportCode : "",
      airportName: this.CargoInputData.airportDestination.airportName,
      cityCode: this.CargoInputData.airportDestination.cityCode,
      cityName: this.CargoInputData.airportDestination.cityName,
      office: this.CargoInputData.airportOrigin.office,
      participantId: this.CargoInputData.airportOrigin.participantId,
      name: this.CargoInputData.airportDestination.name,
      value:
        this.detailFlightsData &&
        this.detailFlightsData[this.detailFlightsData.length - 1]?.Route != ""
          ? this.detailFlightsData[
              this.detailFlightsData.length - 1
            ]?.Route.split("-")[1]
          : this.CargoInputData.airportDestinationCode != ""
          ? this.CargoInputData.airportDestinationCode
          : this.CargoInputData.airportDestination.airportCode ? this.CargoInputData.airportDestination.airportCode : ""
    },
    flightsData: this.detailFlightsData,
    nextFlightsData: this.detailNextFlightsData,
    nextConfigCargoFlight: this.detailFlightsData,
    airports: [] as any[],
    transit: "0",
    isChangeAirport: false,
    estDimension: {
      length: 0,
      width: 0,
      height: 0
    },
    actualDimension: {
      length: this.CargoInputData.dimension.length,
      width: this.CargoInputData.dimension.width,
      height: this.CargoInputData.dimension.height
    },
    ngenCreatedAt: "",
    isRtc: this.flowBooking == "rtc-process" ? true : false,
    thresholdTime: this.CargoInputData.thresholdTime,
    shcName: "" as any,
    shcCode: "" as any,
    isValidAwb: true,
    isValidOriginOrDestination: true,
    awbTracking: [] as AwbTracking[],
    photoProof: [] as any[]
  };
  public sttResultFinal: CargoDetailStt[] = JSON.parse(
    getDataSessionStorage("cargo") || "[]"
  );
  public bagResult: {
    baggingNumber: string;
    bagGrossWeight: number;
    stt: CargoDetailStt[];
  }[] = JSON.parse(getDataSessionStorage("cargo-bag") || "[]");
  public sourceSttFromLocalStorage: CargoDetailStt[] = JSON.parse(
    getDataSessionStorage("cargo") || "[]"
  );
  regionBaggingGrouping = new RegionBaggingGrouping({
    baggingRegionDestinationId: "",
    baggingRegionDestinationName: ""
  });
  public destinationCity: any = this.CargoInputData.destinationCityData;
  public showNotesDestination = false;
  public loadingRegion = false;
  public showNotificationWeight = false;
  public isChangePlaneSchedule = false;
  public isPlaneBooking = false;
  public isShowPlaneSchedule = false;

  public cargoCommodityList = new CargoCommodityList(new Pagination(1, 10), []);
  public isLoadingCargoCommodity = false;
  public isLoadingAppend = false;
  public modalSuccessAppend = false;
  public isErrorAppend = false;
  public errorCauseAppend = "";
  public bagSttDetail = new ResponseBagSttDetail();
  public isFullBooked = false;
  public isCargoAvailable = false;
  public isFillForm: boolean =
    getDataSessionStorage("fill-form") == "true" || false;
  public isDeleteStt = JSON.parse(
    getDataSessionStorage("is-delete-stt") || "false"
  );
  public airportsPopupModel: any[] = [];
  public isShowBookingForm = false;
  public listLastReadCargo: ListLastReadCargo[] = [];
  public progressValue = JSON.parse(
    getDataSessionStorage("progress-value") || "0"
  );
  public cargoStatus = "";
  public cancelFromDetail = false;
  public deleteFromDetail = false;
  public isCacheCommodityGroup = false;
  public showModalCargoType: boolean =
    (getDataSessionStorage("show-modal-cargo") == "true" ? true : false) ||
    false;
  public isEditReadyToCargo =
    (getDataSessionStorage("isEditReadyToCargo") == "true" ? true : false) ||
    false;
  public isPlaneAutoFlow = false;
  public commodityItem: OptionsClass = new OptionsClass({
    name: this.cargoInputForm.cargoComodity?.name,
    code: this.cargoInputForm.cargoComodity?.code
  });
  public commodityOptions: OptionsClass[] = [];
  public lastReadCargoSession: { start: 0; end: 0 } = JSON.parse(
    getDataSessionStorage("last-read-cargo") || "{}"
  );
  public calculateTotalGrossWeight = 0;
  public disableCommodityGroup = false;
  public isErrorInputStepThree = {
    dimension: false,
    volumeWeight: false,
    grossWeight: false,
    totalPieces: false
  };
  public isShowPlaneScheduleFromLocalStorage =
    getDataSessionStorage("setShowPlaneSchedule") == "true" || false;
  public showPopupDimensionPieces = false;
  public formDetailPieces: {
    totalPieces: number;
    dimensionPieces: DimensionPieces[];
  } = {
    totalPieces: 0,
    dimensionPieces: [
      {
        pieces: 0,
        length: 30,
        width: 20,
        height: 10,
        grossWeight: 1
      }
    ]
  };

  public isHaveBeenSubmitDetailPieces = false;
  public isErrorDiffPiecesActualThanDimensionPieces = false;
  public isChangeCargoType = JSON.parse(
    getDataSessionStorage("cargo-is-change-cargo-type") || "false"
  );
  public tabsList = JSON.parse(getDataSessionStorage("cargo-tabs-list") || "[]");
  public isShowModalGamification = JSON.parse(
    getDataSessionStorage("is-modal-gamification") || "false"
  );
  public isModalGamificationDone = JSON.parse(
    getDataSessionStorage("is-modal-gamification-done") || "false"
  );
  public isChangeVolumeActual = JSON.parse(
    getDataSessionStorage("is-change-total-actual-volume") || "false"
  );
  public isFromRtc = false;

  public isRebookingFromRTC = JSON.parse(
    getDataSessionStorage("is-from-rebooking-rtc") || "false"
  );
  public isTimeoutNgen = false;
  public destinationCityRTC: any = "";
  public clientValue: any = "";
  public readyToCargoList = new ReadyToCargoListEntities({
    pagination: {
      page: 1,
      limit: 20
    },
    data: []
  });
  public activeTabs = "plane";
  public isBookingAuto = false;
  public isOverCutOffTime = false;
  public isErrorMaxGrossWeight = false;
  public isErrorMaxVolumeWeight = false;
  public isErrorMaxPieces = false;
  public searchFlight: SearchFlight[] = [];
  public isLoadingSearchFlight = false;
  public errorCauseSearchFlight = "";
  public totalPcs = 0;
  public hubIdsSelected: number[] = [];
  public dimensionPerKoliData = new DimensionPerKoliData(
    JSON.parse(getDataSessionStorage("cargo-pieces-dimension") || "[]")
  );
  public dimensionPerKoliDataEdit = new DimensionPerKoliData();
  public isDimensionSaved = JSON.parse(
    getDataSessionStorage("is-dimension-saved") || "false"
  );
  public isSttUpdated = JSON.parse(
    getDataSessionStorage("is-stt-updated") || "false"
  );
  public isAwbValid = JSON.parse(
    getDataSessionStorage("is-awb-valid") || "false"
  );
  public disableDelay = false;
  public scanFailedList: CargoScanFailed[] = [];
  public isFirstLandingEditRTC = false;
  public isLoadingCargoDispute = false;
  public cargoDisputeSummaryData = new CargoDisputeSummaryData();
  public cargoMinimumWeightSummaryData = new CargoMinimumWeightSummaryData()
  public itemToDelete = new CargoDetailStt();
  public cargoSuccessSummaryData = new CargoSuccessSummaryData();
  public summaryInProcessValue = new CargoSummaryInProcessData();
  public cargoFailedUnreadData = new CargoFailedUnread();

  @Action
  public async getCargoList(params: CargoListRequest) {
    const requestParams = new CargoListRequest({
      ...params,
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : ""
    });
    this.setLoading(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoList(requestParams)
      .then((res: any) => {
        this.setCargoList(res);
        this.setError(false);
        this.setErrorCause("");
        return res.data;
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
        return this.cargoData.data;
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  @Action
  public async getCargoDisputeSummary() {
    const accountOrigin = AccountController.accountData.account_location.city_code;
    const requestParams = new CargoListRequest({
      originCity: this.advanceFilterData.cityOriginCode
        ? this.advanceFilterData.cityOriginCode
        : accountOrigin,
      destinationCity: this.advanceFilterData.cityDestinationCode,
      destinationAirport: this.advanceFilterData.airport,
      startDate: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      endDate: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : "",
      cargoTypes: this.cargoTypes.length ? this.cargoTypes.join(',') : "",
    });
    this.setLoadingCargoDispute(true)
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoDisputeSummary(requestParams)
      .then((res: any) => {
        this.setCargoDisputeSummaryData(res)
        return res;
      })
      .catch((error: any) => {
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        this.setLoadingCargoDispute(false)
      })
  }

  @Action
  public async getCargoSuccessSummary() {
    const requestParams = new CargoListRequest({
      startDate: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      endDate: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : "",
      // cargoTypes: this.cargoTypes.length ? this.cargoTypes.join(',') : "",
      destinationCity: this.advanceFilterData.cityDestinationCode,
      destinationAirport: this.advanceFilterData.airport
    });
    this.setLoading(true)
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoSuccessSummary(requestParams)
      .then((res: any) => {
        this.setCargoSuccessSummaryData(res)
        return res;
      })
      .catch((error: any) => {
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        this.setLoading(false)
      })
  }

  @Action
  public downloadExcelCargoSummaryDispute(cargoType: string) {
    MainAppController.showLoading();
    const payload = {
      start_date: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      end_date: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hub_ids: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : "",
      cargo_type: cargoType === 'all' ? "" : cargoType,
    };
    const presenter = container.resolve(CargoPresenter);
    presenter
      .downloadExcelCargoDisputeSummary(payload)
      .then((res) => {
        return {
          data: res,
          success: true
        };
      })
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Download Gagal !", () => {
            MainAppController.closeErrorMessage();
          })
        );
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        MainAppController.closeLoading()
      });
  }

  @Action
  public getRetryCargoList(params: CargoListRequest) {
        const requestParams = new CargoListRequest({
      ...params,
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : ""
    });
    this.setLoading(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getRetryCargoList(requestParams)
      .then((res: any) => {
        this.setRetryCargo(res);
        this.setError(false);
        this.setErrorCause("");
        return res.data;
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
        return this.retryCargo.data;
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  @Action
  public handleGetLastReadCargo(isExpired: boolean, isEmpty: boolean) {
    if (isExpired) {
      this.getLastReadCargo();
      this.setLastReadCargoSession({
        start: new Date().getTime(),
        end: new Date(new Date().getTime() + 5 * 60000).getTime()
      });
    }
    if (isEmpty) {
      this.getLastReadCargo();
      this.setLastReadCargoSession({
        start: new Date().getTime(),
        end: new Date(new Date().getTime() + 5 * 60000).getTime()
      });
    }
  }

  @Action
  public getLastReadCargo() {
    const presenter = container.resolve(CargoPresenter);
    presenter.getListLastCargo().then((res: ListLastReadCargo[]) => {
      const toast = app.config.globalProperties.$toast;
      if (res.length !== 0) {
        const checkStatus = !!res.find((item: any) => {
          return item.status === "failed";
        });
        if (checkStatus) {
          playNotification("failed_cargo");
        } else {
          playNotification("success_cargo");
        }
        res.forEach((item: ListLastReadCargo) => {
          toast.add({
            severity: item.status === "success" ? "success" : "error",
            detail: `<b>No. Kargo ${item.cargoNumber}</b> ${
              item.status === "success"
                ? `Berhasil Booking kargo ke <b>${item.destination}</b>`
                : `Gagal Booking ${
                    item.message?.toLowerCase().includes("sistem")
                      ? `ke ${item.destination} karena <b>terjadi kendala sistem</b>`
                      : `karena <b>${item.message}</b>`
                  }`
            }`,
            life: 10000
          });
        });
      }
    }).catch((err: any) => {
      console.warn(err);
    })
  }

  @Action
  public updateLastReadCargo() {
    const presenter = container.resolve(CargoPresenter);
    presenter
      .updateListLastCargo()
      .then(() => {
        return true;
      })
      .catch(err => {
        return false;
      });
  }

  @Action
  public getDetailCargo(params: { id: string | number; isPrint: boolean }) {
    if (params.isPrint) {
      MainAppController.showLoading();
      MainAppController.closeErrorMessage();
    } else {
      this.setLoading(true);
    }

    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getDetailCargo(params.id)
      .then((res: CargoData) => {
        const country = AccountController.accountData?.countryCode ?? "ID";
        res["totalActualCargoGrossWeight"] = formatByCountry(Number(res.totalActualCargoGrossWeight), { type: "weight", country });
        res["totalActualCargoVolumeWeight"] = formatByCountry(Number(res.totalActualCargoVolumeWeight), { type: "weight", country });
        this.setCargoDetailData(res);
        this.setError(false);
        this.setErrorCause("");
        return res;
      })
      .catch((error: any) => {
        if (params.isPrint) {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error, "Print Gagal !", () =>
              this.getDetailCargo(params)
            )
          );
        } else {
          this.setError(true);
          this.setErrorCause(error.response ? "server" : "internet");
        }

        return new CargoData();
      })
      .finally(() => {
        if (params.isPrint) {
          MainAppController.closeLoading();
        } else {
          this.setLoading(false);
        }
      });
  }

  @Action
  public getDetailCargoByCargoNo(params: { cargoNo: string; isPrint: boolean }) {
    if (params.isPrint) {
      MainAppController.showLoading();
      MainAppController.closeErrorMessage();
    } else {
      this.setLoading(true);
    }

    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getDetailCargoByCargoNo(params.cargoNo)
      .then((res: CargoData) => {
        const country = AccountController.accountData?.countryCode ?? "ID";
        res["totalActualCargoGrossWeight"] = formatByCountry(Number(res.totalActualCargoGrossWeight), { type: "weight", country });
        res["totalActualCargoVolumeWeight"] = formatByCountry(Number(res.totalActualCargoVolumeWeight), { type: "weight", country });
        this.setCargoDetailData(res);
        this.setError(false);
        this.setErrorCause("");
        return res;
      })
      .catch((error: any) => {
        if (params.isPrint) {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error, "Print Gagal !", () =>
              this.getDetailCargoByCargoNo(params)
            )
          );
        } else {
          this.setError(true);
          this.setErrorCause(error.response ? "server" : "internet");
        }

        return new CargoData();
      })
      .finally(() => {
        if (params.isPrint) {
          MainAppController.closeLoading();
        } else {
          this.setLoading(false);
        }
      });
  }

  @Action
  public getDetailRetryCargo(params: { cargoNo: string; isPrint: boolean, version?: string }) {
    if (params.isPrint) {
      MainAppController.showLoading();
      MainAppController.closeErrorMessage();
    } else {
      this.setLoading(true);
    }

    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getDetailRetryCargo(params.cargoNo, params.version)
      .then((res: CargoData) => {
        const country = AccountController.accountData?.countryCode ?? "ID";
        res["totalActualCargoGrossWeight"] = formatByCountry(Number(res.totalActualCargoGrossWeight), { type: "weight", country });
        res["totalActualCargoVolumeWeight"] = formatByCountry(Number(res.totalActualCargoVolumeWeight), { type: "weight", country });
        this.setCargoDetailData(res);
        this.setError(false);
        this.setErrorCause("");
        return res;
      })
      .catch((error: any) => {
        if (params.isPrint) {
          MainAppController.showErrorMessage(
            parsingErrorResponse(error, "Print Gagal !", () =>
              this.getDetailRetryCargo(params)
            )
          );
        } else {
          this.setError(true);
          this.setErrorCause(error.response ? "server" : "internet");
        }

        return new CargoData();
      })
      .finally(() => {
        if (params.isPrint) {
          MainAppController.closeLoading();
        } else {
          this.setLoading(false);
        }
      });
  }

  @Action
  public searchAction(value: string) {
    this.setSearch(value);
    this.setFirstPage();
    this.fetchCargoList({ type: this.cargoStatus ? "retry" : "" });
  }

  @Action
  public fetchCargoList(params = { type: "" }) {
    const accountOrigin =
      AccountController.accountData.account_location.city_code;
    const payload = new CargoListRequest({
      page: this.cargoStatus
        ? this.retryCargo.pagination.page
        : this.cargoData.pagination.page,
      limit: this.cargoStatus
        ? this.retryCargo.pagination.limit
        : this.cargoData.pagination.limit,
      search: encodeURIComponent(this.search),
      cargoTypes: this.cargoTypes.length ? this.cargoTypes.join(',') : "",
      originCity: this.advanceFilterData.cityOriginCode
        ? this.advanceFilterData.cityOriginCode
        : accountOrigin,
      destinationCity: this.advanceFilterData.cityDestinationCode,
      startDate: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      endDate: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      destinationAirport: this.advanceFilterData.airport,
      status: this.cargoStatus ?? "",
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : ""
    });
    return params.type === "retry"
      ? this.getRetryCargoList(payload)
      : this.getCargoList(payload);
  }

  @Action
  public async fetchLastIdCargoRetryCargo(type: string) {
    const accountOrigin =
      AccountController.accountData.account_location.city_code;
    const payload = new CargoListRequest({
      cargoType: this.advanceFilterData.type.value,
      originCity: this.advanceFilterData.cityOriginCode
        ? this.advanceFilterData.cityOriginCode
        : accountOrigin,
      destinationCity: this.advanceFilterData.cityDestinationCode,
      status: this.cargoStatus ?? "",
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : ""
    });
    try {
      if (type === "retry-cargo") {
        const presenter = container.resolve(CargoPresenter);
        return await presenter.getLastIdRetryCargo(payload);
      } else {
        const presenter = container.resolve(CargoPresenter);
        return await presenter.getLastIdCargo(payload);
      }
    } catch (error) {
      return 0;
    }
  }

  @Mutation
  public setHubIdsSelected(val: number[]) {
    this.hubIdsSelected = val;
  }

  @Mutation
  public setCargoDisputeSummaryData(data: CargoDisputeSummaryData) {
    this.cargoDisputeSummaryData = data;
  }

  @Mutation
  public setCargoSuccessSummaryData(data: CargoSuccessSummaryData) {
    this.cargoSuccessSummaryData = data;
  }

  @Mutation
  public setCargoTypes(data: string[]) {
    this.cargoTypes = data;
  }

  @Mutation 
  public setCargoMinimumWeightSummary(data: CargoMinimumWeightSummaryData) {
    this.cargoMinimumWeightSummaryData = data
  }

  @Action
  public getAirportList(params: {
    airportCode: string;
    cityCode: string;
    page: number;
    limit: number;
    isLocation?: boolean;
    hideDefault?: boolean;
    search?: string;
  }) {
    this.setLoadingAirport(true);
    const presenter = container.resolve(CargoPresenter);
    presenter
      .getAirportList(
        params.airportCode,
        params.cityCode,
        params.page,
        params.limit,
        params.isLocation,
        params.search
      )
      .then((res: AirportEntities) => {
        this.setAirportList(res);
        this.setErrorCause("");
      })
      .catch((error: any) =>
        this.setErrorCause(error.response ? "server" : "internet")
      )
      .finally(() => this.setLoadingAirport(false));
  }

  @Action
  public getAirportDetail(params: { airportCode: string }) {
    this.setLoadingAirport(true);
    const presenter = container.resolve(CargoPresenter);
    presenter
      .getAirportDetail(params.airportCode)
      .then((res: AirportDetail) => {
        this.setAirportDetail(res);
        this.setErrorCause("");
      })
      .catch((error: any) =>
        this.setErrorCause(error.response ? "server" : "internet")
      )
      .finally(() => this.setLoadingAirport(false));
  }
  @Action
  public async getAirportRouteType(params: {
    originCityCode: string;
    destinationCityCode: string;
  }): Promise<AirportRouteTypeData | null> {
    const presenter = container.resolve(CargoPresenter);
    try {
      return await presenter.getAirportRouteType(
        new AirportRouteTypeApiRequest({
          originCityCode: params.originCityCode,
          destinationCityCode: params.destinationCityCode
        })
      );
    } catch (error) {
      return null;
    }
  }

  @Action
  public getAirportDetailOrigin(params: {
    airportCode: string;
  }): Promise<boolean> {
    this.setLoadingAirport(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getAirportDetail(params.airportCode)
      .then((res: AirportDetail) => {
        this.setAirportDetailOrigin(res);
        this.setErrorCause("");
        return true;
      })
      .catch((error: any) => {
        this.setErrorCause(error.response ? "server" : "internet");
        throw false;
      })
      .finally(() => this.setLoadingAirport(false));
  }
  @Action
  public getAirportDetailDestination(params: {
    airportCode: string;
  }): Promise<boolean> {
    this.setLoadingAirport(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getAirportDetail(params.airportCode)
      .then((res: AirportDetail) => {
        this.setAirportDetailDestination(res);
        this.setErrorCause("");
        return true;
      })
      .catch((error: any) => {
        this.setErrorCause(error.response ? "server" : "internet");
        throw false;
      })
      .finally(() => this.setLoadingAirport(false));
  }

  @Action
  public async getAirportListOrigin(params: {
    airportCode: string;
    cityCode: string;
    page: number;
    limit: number;
    isLocation?: boolean;
    hideDefault?: boolean;
  }) {
    this.setLoadingAirport(true);
    MainAppController.showLoading();
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getAirportList(
        params.airportCode,
        params.cityCode,
        params.page,
        params.limit,
        params.isLocation
      )
      .then((res: AirportEntities) => {
        this.setAirportOriginList(res);
        this.setError(false);
        this.setErrorCause("");
        const findDefault = this.form.airportOrigin.airportCode === 'CGK' ?  res.data.find(airport => airport.airportCode === "CGK") : res.data[0];
        if (findDefault && !params.hideDefault) {
          this.setDefaultAirportOrigin(findDefault);
      }
        return true;
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
        return false;
      })
      .finally(() => {
        this.setLoadingAirport(false);
        MainAppController.closeLoading();
      });
  }

  @Action
  public async getAirportListDestination(params: {
    airportCode: string;
    cityCode: string;
    page: number;
    limit: number;
    isLocation?: boolean;
    isFilter?: boolean
  }) {
    this.setLoadingAirport(true);
    if (!params.isFilter) MainAppController.showLoading();
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getAirportList(
        params.airportCode,
        params.cityCode,
        params.page,
        params.limit,
        params.isLocation
      )
      .then((res: AirportEntities) => {
        this.setAirportDestinationList(res);
        this.setError(false);
        this.setErrorCause("");
        const findDefault = res.data[0];
        if (findDefault) {
          this.setDefaultAirportDestination({
            ...findDefault,
            airportName: `${findDefault.airportCode} - ${findDefault.airportName}`
          });

          if (
            this.form.airports.length > 2 &&
            this.form.destinationCityCode ===
              this.form.airports[this.form.airports.length - 1].airportCode
          ) {
            this.form.airports.splice(1, 1);
          }
        }
        return true;
      })
      .catch((error: any) => {
        this.setError(true);
        this.setErrorCause(error.response ? "server" : "internet");
        return false;
      })
      .finally(() => {
        this.setLoadingAirport(false);
        if (!params.isFilter) MainAppController.closeLoading();
      });
  }

  @Action
  public getCargoSttValidation(bagOrStt: string) {
    const bagNo = !bagOrStt.match(/^\d/g) ? `${bagOrStt}-xxxxxxxxxxxxx` : "";
    return new CargoSttList(
      Array(bagNo ? 6 : 1)
        .fill("")
        .map(
          (_, index) =>
            new CargoSttValidaton(
              true,
              "",
              new CargoSttDetail({
                bagNo: bagNo,
                sttId: index,
                sttNo: `${index}${bagOrStt}`,
                sttTotalPiece: 3,
                sttGrossWeight: 30,
                sttVolumeWeight: 30,
                sttProductType: "-",
                sttCommodityCode: "all",
                sttCommodityName: "All Commodity",
                piece: [new CargoPieceDetail(index, 30, 30, index)]
              })
            )
        )
    );
  }

  @Action
  public onEditCargo(params: {
    cargoId: number;
    cargoNo: string;
    actualTotalGrossWeight: number;
    actualTotalVolumeWeight: number;
    bagOrStt: EditCargoBagOrStt[];
    cargoActualPiece: number;
    actualDimension: DimensionData;
    partnerId?: number;
    dimensions?: DimensionPieces[];
    photoProof?: string[];
    cargoTotalEstimateGrossWeight?: number;
    cargoTotalEstimateVolumeWeight?: number;
    cargoTotalChargeableWeight?: number;
    cargoTotalCustomChargeableWeight?: number;
    cargoTotalEstimateChargeableWeight?: number;
    isNewCalculation?: boolean;
    calculateType?: string;
    isValidAwbManual?: boolean,
    isCargoDimensionOn?: boolean,
    cargoTypeStatus?: string,
    currentChargeableWeight?: number
  }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .editCargo(
        new EditCargoApiRequest(
          params.cargoNo,
          params.actualTotalGrossWeight,
          params.actualTotalVolumeWeight,
          params.cargoActualPiece,
          params.bagOrStt,
          params.actualDimension,
          params.partnerId,
          params.dimensions,
          params.photoProof,
          params.cargoTotalEstimateGrossWeight,
          params.cargoTotalEstimateVolumeWeight,
          params.cargoTotalChargeableWeight,
          params.cargoTotalCustomChargeableWeight,
          params.cargoTotalEstimateChargeableWeight,
          params.isNewCalculation,
          this.cargoDetailData.cargoType,
          params.calculateType,
          params.isValidAwbManual,
          params.isCargoDimensionOn,
          params.cargoTypeStatus,
          params.currentChargeableWeight,
          params.cargoId
        )
      )
      .then(res => {
        this.setError(false);
        this.setErrorCause("");
        this.setCargoIdToGeneratePdf(res.cargoNo);
        return res;
      })
      .catch(err => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            err,
            this.isAccountForeign
              ? "Failed to Update Cargo !"
              : "Perubahan Kargo Gagal!",
            () => this.onEditCargo(params)
          )
        );
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  @Mutation
  dataLayerSearchCargo(params: {
    type: string;
    params?: any;
    res?: any;
    errorMessage?: string;
  }) {
    const cargoType: any = {
      plane: "Pesawat (Booking Manual),Pesawat (Booking Auto)",
      truck: "Truk (Booking Manual)",
      train: "Kereta (Booking Manual)"
    };

    switch (params.type) {
      case "success":
        dataLayer(
          "search_cargo_success",
          {
            origin_city: `${params?.params?.origin?.code} - ${params?.params?.origin?.name}`,
            destination_city: params?.params?.destination?.name,
            cargo_type_list: params.res.data.find(
              (e: any) => e.transportType === "plane"
            )
              ? params.res.data.length + 1
              : params.res.data.length,
            cargo_type: params.res.data
              .map((cargo: any) => cargoType[cargo.transportType])
              .toString()
          },
          []
        );
        break;

      case "failed":
        dataLayer(
          "search_cargo_failed",
          {
            error_message: params.errorMessage,
            origin_city: `${params?.params?.origin?.code} - ${params?.params?.origin?.name}`,
            destination_city: params?.params?.destination?.name
          },
          []
        );
        break;

      default:
        break;
    }
  }

  @Action
  getCargoOptions(params: {
    origin: { code: string; name: string };
    destination: { code: string; name: string };
    isPlaneManual: boolean;
  }) {
    const cargoInputForm: CargoInputData = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    cargoInputForm.originCityData = new OriginCityData({
      name: params.origin.name,
      code: params.origin.code
    });
    storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
    this.setShowCargoOptions(false);
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    presenter
      .getSearchCargoOptions(params.origin.code, params.destination.code)
      .then(res => {
        const includesPlane =
          res.data?.filter(key => key.transportType === "plane").length > 0;
        if (includesPlane && params.isPlaneManual) {
          res.data.splice(0, 0, {
            transportLabel: "Cargo Plane Manual",
            transportType: "plane-manual"
          });
        }

        const today = {
          hours: formatDate(new Date())
            ?.split(",")[1]
            ?.split(":")[0]
            ?.trim(),
          minutes: formatDate(new Date())
            ?.split(",")[1]
            ?.split(":")[1]
            ?.replace(/\bwib\b|\bwita\b|\bwit\b|\bgmt\b/gi, "")
            ?.trim()
        };
        const isAllowed =
          (+this.cutOffTime.hours < +today.hours ||
            (+this.cutOffTime.hours === +today.hours &&
              +this.cutOffTime.minutes < +today.minutes)) &&
          this.progressValue !== -1;
        if (this.accountIsForeign || (this.isAllowEditCutoff && isAllowed)) {
          //remove plane auto if account is foreign
          res.data = res.data.filter(key => key.transportType !== "plane");
        }
        this.setCargoOptions(res);
        this.setShowCargoOptions(true);
        this.setError(false);
        this.setErrorCause("");
        this.setCargoAvailable(!res.data.length);
        const tabList = res.data.map((item: any) => {
          return {
            title: cargoTypeData(item.transportType).label,
            name: item.transportType
          };
        });
        if (!params.isPlaneManual) {
          this.setCargoListTab(tabList);
          storeDatatoSessionStorage("cargo-tabs-list", tabList);
        }

        // GTM
        if (res.data.length) {
          this.dataLayerSearchCargo({ type: "success", res, params });
        } else {
          this.dataLayerSearchCargo({
            type: "failed",
            errorMessage:
              "maaf jumlah cargo yang anda pilih sudah penuh atau tidak tersedia",
            params
          });
        }
      })
      .catch(err => {
        // GTM
        this.dataLayerSearchCargo({
          type: "failed",
          errorMessage: err?.response?.data?.message?.id,
          params
        });
        if (!FlagsPermissionCargo.feature_flight_v2_enable.isEnabled()) {
          MainAppController.showErrorMessage(
            parsingErrorResponse(
              err,
              this.isAccountForeign
                ? "Cargo Search Failed!"
                : "Cari Kargo Gagal!",
              () => this.getCargoOptions(params)
            )
          );
        }
      })
      .finally(() => {
        MainAppController.closeLoading();
      });
  }

  get accountIsForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  @Action
  public getCargoProductList(params: { status: string }) {
    this.setLoadingCargoProductList(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoProductList(params.status)
      .then((res: CargoProductEntities) => {
        this.setCargoProductList(res);
        this.setCargoProductListError(false);
        this.setCargoProductLisErrorCause("");
      })
      .catch((error: any) => {
        this.setCargoProductListError(false);
        this.setCargoProductLisErrorCause(
          error.response ? "server" : "internet"
        );
      })
      .finally(() => {
        this.setLoadingCargoProductList(false);
      });
  }

  @Action
  public appendBagOrSttNumber(params: {
    bagOrStt: BagOrSttNumber;
    cargoProductType: string;
    cargoCommodity: string;
    cargoType: string;
    callback: any;
    partnerId?: number;
    storageKey?: string;
  }) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .appendBagOrSttNumber(
        new AddBagOrSttNumberRequest(
          params.bagOrStt,
          params.cargoProductType,
          params.cargoCommodity,
          params.cargoType,
          params.partnerId
        )
      )
      .then((res: ResponseBagSttDetail) => {
        this.setBagSttDetail(res);
        this.setOpenModalSuccessAppend(true);
        params.callback(res);
        return true;
      })
      .catch(error => {
        this.setErrorAppend(true);
        playNotification("error");
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            error,
            this.isAccountForeign ? "Add Failed" : "Tambah No. STT Gagal !",
            () => {
              MainAppController.closeErrorMessage();
              this.appendBagOrSttNumber(params);
            }
          )
        );

        const message = (error as any)?.response?.data?.message;

        if (typeof message !== "string") {
          const { stt_no, bag_no } = params.bagOrStt;

          this.addScanFailedList(
            new CargoScanFailed({
              sttNumber: stt_no || bag_no,
              failureReason: parsingErrorResponse(error).message,
              storageKey: params.storageKey
            })
          );
        }

        return false;
      })
      .finally(() => {
        this.setOpenModalSuccessAppend(false);
        MainAppController.closeLoading();
      });
  }

  @Action
  private _resetStateAfterBookingCargo(res: CargoAddResponse) {
    this.setError(false);
    this.setErrorCause("");
    this.setCargoIdToGeneratePdf(res.cargoNo);
    this.setIsOverCutOffTime(false);
  }

  @Action
  private _setGTMFailedCreateCargo(params: CreateCargoParams) {
    // GTM
    const gtmBookingCargoFailed = gtmCargoData({
      type: params.cargoType,
      isAuto:
        this.form.cargoType === "plane" &&
        this.form.cargoTypeStatus === "auto"
    }).bookingCargoFailed;
    GTMBookingCargoEvent(ReadyToCargoController.eventName, {
      cargo_type: this.form.cargoType,
      "3LC_origin": LocationController.districtDetail.cityCode,
      "3LC_destination": this.form.destinationCityCode,
      booking_result: "failed",
      cargo_number: this.cargoIdToGeneratePdf,
      timestamp_booking: this.timestampBooking,
      timestamp_get_result: new Date().getTime()
    });
    dataLayer(
      gtmBookingCargoFailed.eventName,
      gtmBookingCargoFailed.property,
      ["timestamp"]
    );
  }

  @Action
  public async onCreateCargo(params: CreateCargoParams) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    return new Promise((resolve, reject) => {
    presenter
      .createCargo(
        new AddCargoRequest(
          params.originAirportCode,
          params.destinationAirportCode,
          params.estTotalCargoGrossweigth,
          params.estTotalCargoVolumeweight,
          params.partnerName,
          params.partnerType,
          params.cargoNo,
          params.cargoVehicleNo,
          params.actualTotalCargoGrossweigth,
          params.actualTotalCargoVolumeweight,
          params.route,
          params.totalStt,
          params.totalPiece,
          params.cargoCommodity,
          params.productCargo,
          params.cargoType,
          params.originCityCode,
          params.destinationCityCode,
          params.departureDate,
          params.arrivalDate,
          params.bagOrStt,
          params.isCargoPlaneManual,
          params.cargoOverCutoffLimit,
          params.isFromRtc ? this.isBookingAuto : false,
          params.cargoActualPiece,
          params.isFromRtc,
          params.rtcId,
          params.flightPlanForECargo,
          params.dimensions,
          params.estDimension,
          params.actualDimension,
          params.nog,
          params.rebookingId,
          params.ngenCreatedAt,
          params.shc,
          params.isFromScheduleCard,
          params.sequentialFlight,
          params.totalFlight,
          params.photoProof,
          params.cargoTotalChargeableWeight,
          params.cargoTotalCustomChargeableWeight,
          params.cargoTotalEstimateChargeableWeight,
          params.isNewCalculation,
          params.calculateType,
          this.isAwbValid,
          params.isCargoDimensionOn,
          this.initCalculateVolumeData.chargeableWeight || 0
        )
      )
      .then(res => {
        this._resetStateAfterBookingCargo(res); // for codescene purpose
        resolve(res);
        return res;
      })
      .catch(err => {
        // GTM
        this._setGTMFailedCreateCargo(params)
        reject(err);
        if (params.isFromScheduleCard) return;
      })
      .finally(() => MainAppController.closeLoading());
    })
  }

  @Action
  public _resetCargoDataAfterFailedBookingCargo() {
    storeDatatoSessionStorage("cargo", []);
    storeDatatoSessionStorage("show-select-airport", false);
    storeDatatoSessionStorage("cargo-bag", []);
    storeDatatoSessionStorage("event-name", "");
    storeDatatoSessionStorage("rtc-flights-data", []);
    storeDatatoSessionStorage("next-rtc-flights-data", []);
    storeDatatoSessionStorage("calculate-flight-date", []);
    storeDatatoSessionStorage("cargo-type", {});
    storeDatatoSessionStorage("is-change-total-actual-volume", false);
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY,
      false
    );
    this.setShowSelectAirportToLocalStorage(false);
    ReadyToCargoController.setReadyToCargoDetail(
      new ReadyToCargo()
    );
    this.setDimensionPerKoliData(new DimensionPerKoliData());
    this.setIsDimensionSaved(false);
    this.setIsSttUpdated(false);
    this.setIsAwbValid(false);
    ReadyToCargoController.setCalculateFlightDate([]);
    ReadyToCargoController.setDetailFlightData([]);
    ReadyToCargoController.setDetailNextFlightData([]);
    ReadyToCargoController.setFlowBooking("");
    this.setIsChangeVolumeActual(false);
    this.resetCargoInputForm(new CargoInputData());
    this.setSourceFromLocalStorage([]);
    this.setSTTResultFinal([]);
    this.setBagResult([]);
    this.resetForm();
    MainAppController.closeErrorMessage();
  }

  get isAccountForeign() {
    return AccountController.accountData.accountIsForeign;
  }

  @Action
  public cancelCargo() {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    presenter
      .updateRetryCargo(
        this.cargoIdToCancelOrDelete,
        new UpdateRetryCargoRequest("cancel"),
        FlagsPermissionCargo.config_version_cancel_cargo.getValue()
      )
      .then(res => {
        this.setError(false);
        this.setErrorCause("");
        this.setCargoIdToCancelOrDelete(0);
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: "Data Berhasil Dibatalkan",
            message: `No. Kargo ${this.cargoNoForModal} telah dibatalkan dan masuk ke dalam list Gagal/Dibatalkan`,
            textSuccess: "OK",
            onSubmit: () => {
              MainAppController.closeMessageModal();
              if (this.cancelFromDetail) {
                router.push("/cargo/booking-in-progress");
                this.setDeleteFromDetail(false);
              } else {
                this.fetchCargoList({ type: "retry" });
              }
              this.setCargoNoForModal("");
            },
            image: "cancel-success"
          })
        );
        return res;
      })
      .catch(err => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(err, "Gagal Batal Cargo !", () => {
            MainAppController.closeErrorMessage();
            this.cancelCargo();
          })
        );
      })
      .finally(() => MainAppController.closeLoading());
  }

  @Action
  public deleteCargo() {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    presenter
      .updateRetryCargo(
        this.cargoIdToCancelOrDelete,
        new UpdateRetryCargoRequest("delete")
      )
      .then(res => {
        this.setError(false);
        this.setErrorCause("");
        this.setCargoIdToCancelOrDelete(0);
        MainAppController.showMessageModal(
          new ModalMessageEntities({
            title: "Data Berhasil Dihapus",
            message: `No. Kargo ${this.cargoNoForModal} telah dihapus`,
            textSuccess: "OK",
            onSubmit: () => {
              MainAppController.closeMessageModal();
              this.setCargoNoForModal("");
              if (this.deleteFromDetail) {
                router.push("/cargo/booking-canceled");
                this.setDeleteFromDetail(false);
              } else {
                this.fetchCargoList({ type: "retry" });
              }
            },
            image: "delete-success"
          })
        );
        return res;
      })
      .catch(err => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(err, "Gagal Batal Cargo !", () => {
            MainAppController.closeErrorMessage();
            this.deleteCargo();
          })
        );
      })
      .finally(() => MainAppController.closeLoading());
  }

  @Action
  public getDownloadData(params: { id: number; type: string; version?: string}) {
    MainAppController.showLoading();
    MainAppController.closeErrorMessage();
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getDownloadData(params.id, params.type, params.version || "v1")
      .then((res: string) => {
        return {
          data: res,
          success: true
        };
      })
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Download Gagal !", () => {
            MainAppController.closeErrorMessage();
            this.getDownloadData(params);
          })
        );
        return {
          data: "",
          success: false
        };
      })
      .finally(() => MainAppController.closeLoading());
  }

  @Action
  public downloadListCargoSuccess(payload: DownloadCargoListApiRequest) {
    const presenter = container.resolve(CargoPresenter);
    return presenter.downloadListCargoSuccess(payload);
  }

  @Mutation
  public setFillForm(val: boolean) {
    this.isFillForm = val;
    storeDatatoSessionStorage("fill-form", val);
  }

  @Mutation
  public setIsDeleteStt(val: boolean) {
    this.isDeleteStt = val;
    storeDatatoSessionStorage("is-delete-stt", val);
  }

  @Mutation
  public setHaveBeenSubmit(bool: boolean) {
    this.isHaveBeenSubmitDetailPieces = bool;
  }

  @Mutation
  public setNotificationWeight(val: boolean) {
    this.showNotificationWeight = val;
  }

  @Mutation
  public setShowBookingForm(val: boolean) {
    this.isShowBookingForm = val;
  }

  @Mutation
  public setCargoIdToGeneratePdf(val: string) {
    this.cargoIdToGeneratePdf = val;
  }

  @Mutation
  public setCargoIdToCancelOrDelete(val: number) {
    this.cargoIdToCancelOrDelete = val;
  }

  @Mutation
  public setCargoNoForModal(val: string) {
    this.cargoNoForModal = val;
  }

  @Mutation
  public setBagSttDetail(data: ResponseBagSttDetail) {
    this.bagSttDetail = data;
  }

  @Mutation
  public setShowModalCompleteCargo(val: boolean) {
    this.showModalComplete = val;
  }

  @Mutation
  public setShowModalConfirmCargo(val: boolean) {
    this.showModalConfirm = val;
  }

  @Mutation
  public setLoadingAppend(status: boolean) {
    this.isLoadingAppend = status;
  }

  @Mutation
  public setOpenModalSuccessAppend(status: boolean) {
    this.modalSuccessAppend = status;
  }

  @Mutation
  public setErrorAppend(status: boolean) {
    this.isErrorAppend = status;
  }

  @Mutation
  public setErrorCauseAppend(err: string) {
    this.errorCauseAppend = err;
  }

  @Mutation
  public setLoadingCargoProductList(status: boolean) {
    this.isLoadingCargoProductList = status;
  }

  @Mutation
  public setCargoProductList(data: CargoProductEntities) {
    this.cargoProductList = data;
  }

  @Mutation
  public setCargoProductListError(status: boolean) {
    this.cargoProductListError = status;
  }

  @Mutation
  public setCargoProductLisErrorCause(err: string) {
    this.cargoProductLisErrorCause = err;
  }

  @Mutation
  public setCargoAvailable(status: boolean) {
    this.isCargoAvailable = status;
  }

  @Mutation
  public setCargoListTab(listTab: any) {
    this.tabsList = listTab;
  }

  @Action
  public getCargoCommodityList(params: {
    page: number;
    limit: number;
    search: string;
  }) {
    this.setLoadingCargoCommodity(true);
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoCommodityList(params.page, params.limit, params.search)
      .then(res => {
        this.setCargoCommodityList(res);
      })
      .finally(() => this.setLoadingCargoCommodity(false));
  }

  @Mutation
  public setCargoOptions(val: SearchCargoOptions) {
    this.cargoOptions = val;
  }

  @Mutation
  public setCargoCommodityList(val: CargoCommodityList) {
    this.cargoCommodityList = val;
  }

  @Mutation
  public setLoadingCargoCommodity(val: boolean) {
    this.isLoadingCargoCommodity = val;
  }

  @Mutation
  public setBookingDate(date?: Array<any>) {
    let isDateValid = false;
    date &&
      date.map(e => {
        if (e) isDateValid = true;
        else isDateValid = false;
      });

    this.form["estDepartureDate"] = new Date(
      isDateValid && date ? new Date(date[0]) : new Date()
    ).toISOString();
    this.form["estArrivalDate"] = new Date(
      isDateValid && date
        ? new Date(date[1])
        : new Date().setDate(new Date().getDate() + 6)
    ).toISOString();
  }

  @Mutation
  public resetForm() {
    this.showCargoOptions = false;
    this.isShowPlaneSchedule = false;
    this.form = {
      cargoType: this.cargoType.type || "",
      cargoTypeStatus: this.cargoType.status || "",
      originCityCode: this.CargoInputData.originCityData.code,
      originCityName: this.CargoInputData.originCityData.name,
      destinationCityName:
        this.CargoInputData.destinationCityData.name ||
        this.destinationCity.name,
      destinationCityCode:
        this.CargoInputData.destinationCityData.code ||
        this.destinationCity.code,
      estDepartureDate: this.CargoInputData.estDepartureDate,
      estArrivalDate: this.CargoInputData.estArrivalDate,
      nog: this.CargoInputData.nog,
      estTotalCargoGrossWeight: this.CargoInputData.estTotalCargoGrossWeight.toString(),
      estTotalCargoVolumeWeight: this.CargoInputData.estTotalCargoVolumeWeight.toString(),
      cargoCommodityName: this.CargoInputData.cargoComodity.name ?? "",
      cargoCommodityCode: this.CargoInputData.cargoComodity.code ?? "",
      cargoProduct: this.CargoInputData.cargoProduct,
      cargoNumber: this.CargoInputData.cargoNumber,
      vehicleNumber: this.CargoInputData.vehicleNumber,
      actualTotalCargoGrossWeight: this.CargoInputData.totalActualCargoGrossWeight.toString(),
      actualTotalCargoVolumeWeight: this.CargoInputData.totalActualCargoVolumeWeight.toString(),
      actualTotalSTTPieces: this.CargoInputData.totalActualCargoColi,
      sttList: [] as CargoDetailStt[],
      totalCargoVolumeWeight: 400,
      airportOrigin: {
        airportCode:
          this.detailFlightsData && this.detailFlightsData[0]?.Route
            ? this.detailFlightsData[0]?.Route.split("-")[0]
            : this.CargoInputData.airportOriginCode
            ? this.CargoInputData.airportOriginCode
            : this.CargoInputData.airportOrigin.airportCode ? this.CargoInputData.airportOrigin.airportCode : "",
        airportName: this.CargoInputData.airportOrigin.airportName,
        cityCode: this.CargoInputData.airportOrigin.cityCode,
        cityName: this.CargoInputData.airportOrigin.cityName,
        office: this.CargoInputData.airportOrigin.office,
        participantId: this.CargoInputData.airportOrigin.participantId,
        name: this.CargoInputData.airportOrigin.name,
        value:
          this.detailFlightsData && this.detailFlightsData[0]?.Route
            ? this.detailFlightsData[0]?.Route.split("-")[0]
            : this.CargoInputData.airportOriginCode
            ? this.CargoInputData.airportOriginCode
            : this.CargoInputData.airportOrigin.airportCode ? this.CargoInputData.airportOrigin.airportCode : ""
      },
      airportDestination: {
        airportCode:
          this.detailFlightsData &&
          this.detailFlightsData[this.detailFlightsData.length - 1]?.Route
            ? this.detailFlightsData[
                this.detailFlightsData.length - 1
              ]?.Route.split("-")[1]
            : this.CargoInputData.airportDestinationCode
            ? this.CargoInputData.airportDestinationCode
            : this.CargoInputData.airportDestination.airportCode ? this.CargoInputData.airportDestination.airportCode : "",
        airportName: this.CargoInputData.airportDestination.airportName,
        cityCode: this.CargoInputData.airportDestination.cityCode,
        cityName: this.CargoInputData.airportDestination.cityName,
        office: this.CargoInputData.airportDestination.office,
        participantId: this.CargoInputData.airportDestination.participantId,
        name: this.CargoInputData.airportDestination.name,
        value:
          this.detailFlightsData &&
          this.detailFlightsData[this.detailFlightsData.length - 1]?.Route
            ? this.detailFlightsData[
                this.detailFlightsData.length - 1
              ]?.Route.split("-")[1]
            : this.CargoInputData.airportDestinationCode
            ? this.CargoInputData.airportDestinationCode
            : this.CargoInputData.airportDestination.airportCode ? this.CargoInputData.airportDestination.airportCode : ""
      },
      flightsData: ReadyToCargoController.detailFlightsData,
      nextFlightsData: ReadyToCargoController.detailNextFlightsData,
      nextConfigCargoFlight: ReadyToCargoController.detailFlightsData,
      airports: [],
      transit: "",
      isChangeAirport: false,
      estDimension: {
        length: 0,
        width: 0,
        height: 0
      },
      actualDimension: {
        length: this.CargoInputData.dimension.length,
        width: this.CargoInputData.dimension.width,
        height: this.CargoInputData.dimension.height
      },
      ngenCreatedAt: "",
      isRtc: false,
      thresholdTime: this.CargoInputData.thresholdTime,
      shcCode: this.CargoInputData.cargoComodity.shcCode,
      shcName: this.CargoInputData.cargoComodity.shcName,
      isValidAwb: this.CargoInputData.isValidAwb,
      isValidOriginOrDestination: this.CargoInputData
        .isValidOriginOrDestination,
      awbTracking: this.CargoInputData.awbTracking,
      photoProof: []
    };
    this.calculateVolumeData = new CalculateVolume();
  }

  @Mutation
  public resetModalPlaneAuto() {
    this.form.airportOrigin = {
      airportCode: "",
      airportName: "",
      cityCode: "",
      cityName: "",
      office: "",
      participantId: "",
      name: "",
      value: ""
    };
    this.form.transit = "";
    NGenController.setAwbDetailData(new AwbDetailData());
  }

  @Mutation
  public setShowCargoOptions(val: boolean) {
    this.showCargoOptions = val;
  }

  @Mutation
  public setAirportsPopupModel(val: any) {
    this.airportsPopupModel = val;
  }

  @Mutation
  public setChangePlaneSchedule(val: boolean) {
    this.isChangePlaneSchedule = val;
  }

  @Mutation
  public setPlaneBooking(val: boolean) {
    this.isPlaneBooking = val;
  }

  @Mutation
  public setShowPlaneSchedule(val: boolean) {
    this.isShowPlaneSchedule = val;
    this.isShowPlaneScheduleFromLocalStorage = val;
    storeDatatoSessionStorage("setShowPlaneSchedule", val);
  }

  @Mutation
  public onReset() {
    this.advanceFilterData = {
      type: { name: "", value: "" },
      cityOriginCode: "",
      cityDestinationCode: "",
      airport: ""
    };
    this.search = "";
    this.periodeStart = null;
    this.periodeEnd = null;
    this.cargoTypes = [];
  }

  @Mutation
  private setCargoList(data: CargoEntities) {
    this.cargoData = data;
  }

  @Mutation
  private setRetryCargo(data: CargoEntities) {
    this.retryCargo = data;
  }

  @Mutation
  private setAirportList(data: AirportEntities) {
    this.airportData = data;
  }

  @Mutation
  private setAirportDetail(data: AirportDetail) {
    this.airportDetail = data;
  }
  @Mutation
  private setAirportDetailOrigin(data: AirportDetail) {
    this.airportDetailOrigin = data;
  }
  @Mutation
  private setAirportDetailDestination(data: AirportDetail) {
    this.airportDetailDestination = data;
  }

  @Mutation
  private setAirportOriginList(data: AirportEntities) {
    this.airportDataOrigin = data;
  }

  @Mutation
  private setAirportDestinationList(data: AirportEntities) {
    this.airportDataDestination = data;
  }

  @Mutation
  private setDefaultEmptyAirport() {
    this.form.airports.push(null);
  }

  @Mutation
  public setTotalPcs(val: number) {
    this.totalPcs = val;
  }

  @Mutation
  public setDefaultAirportOrigin(res: AirportData) {
    const airportName = res.airportCode && res.airportName ? `${res.airportCode} - ${res.airportName}` : ""
    const data = {
      airportCode: res.airportCode,
      airportName: airportName,
      cityCode: res.cityCode,
      cityName: firstCapitalize(res.cityName?.toLowerCase()),
      office: res.office,
      participantId: res.participantId,
      name: airportName,
      value: res.airportCode
    };
    this.form.airportOrigin = data;
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.airportOrigin.airportName = data.airportName;
    this.cargoInputForm.airportOrigin.cityCode = data.cityCode;
    this.cargoInputForm.airportOrigin.cityName = data.cityName;
    this.cargoInputForm.airportOrigin.office = data.office;
    this.cargoInputForm.airportOrigin.participantId = data.participantId;
    this.cargoInputForm.airportOrigin.name = data.name;
    this.cargoInputForm.airportOrigin.airportCode = data.airportCode;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    if (this.form.airports.length) return;
    this.form.airports.push(data);
  }

  @Mutation
  public setResetDefaultAirportOrigin() {
    const data = {
      airportCode: "",
      airportName: "",
      cityCode: "",
      cityName: "",
      office: "",
      participantId: "",
      name: "",
      value: ""
    };
    this.form.airports.length = 0;
    this.form.airportOrigin = data;
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.airportOrigin.airportName = data.airportName;
    this.cargoInputForm.airportOrigin.cityCode = data.cityCode;
    this.cargoInputForm.airportOrigin.cityName = data.cityName;
    this.cargoInputForm.airportOrigin.office = data.office;
    this.cargoInputForm.airportOrigin.participantId = data.participantId;
    this.cargoInputForm.airportOrigin.name = data.name;
    this.cargoInputForm.airportOrigin.airportCode = data.airportCode;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  private setDefaultAirportDestination(res: AirportData) {
    const data = {
      airportCode: res.airportCode,
      airportName: res.airportName,
      cityCode: res.cityCode,
      cityName: firstCapitalize(res.cityName?.toLowerCase()),
      office: res.office,
      participantId: res.participantId,
      name: res.airportName,
      value: res.airportCode
    };
    this.form.airports.push(data);
    this.form.airportDestination = data;
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    if (this.cargoInputForm.airportDestination) {
      this.cargoInputForm.airportDestination.airportName = data.airportName;
      this.cargoInputForm.airportDestination.cityCode = data.cityCode;
      this.cargoInputForm.airportDestination.cityName = data.cityName;
      this.cargoInputForm.airportDestination.name = data.name;
      this.cargoInputForm.airportDestination.airportCode = data.airportCode;
      this.cargoInputForm.airportDestination.office = data.office;
      this.cargoInputForm.airportDestination.participantId = data.participantId;
    }
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setSTTResultFinal(data: CargoDetailStt[]) {
    if (!data.length) {
      this.calculateType = "INIT";
      storeDatatoSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_TYPE, "INIT");
    }
    this.sttResultFinal = data;
    storeDatatoSessionStorage("cargo", data);
  }

  @Mutation
  public setBagResult(data: any) {
    this.bagResult = data;
  }

  @Mutation
  private setCargoDetailData(data: CargoData) {
    this.cargoDetailData = data;
    const newCargoInputData = new CargoInputData({
      id: data.id,
      dimension: new DimensionData({
        length: data.actualDimension.length,
        width: data.actualDimension.width,
        height: data.actualDimension.height
      }),
      totalActualCargoGrossWeight: parseByCountry(data.totalActualCargoGrossWeight.toString(), { country: AccountController.accountData?.countryCode ?? "ID" }),
      calcuateActualCargoGrossWeight: parseByCountry(data.totalActualCargoGrossWeight.toString(), { country: AccountController.accountData?.countryCode ?? "ID" }), // explanation https://github.com/Lionparcel/medusa/pull/5753/files#r1285591503
      totalActualCargoVolumeWeight: parseByCountry(data.totalActualCargoVolumeWeight.toString(), { country: AccountController.accountData?.countryCode ?? "ID" }),
      totalActualCargoColi: data.cargoActualPiece,
      originCityData: new OriginCityData({
        code: data.originCityCode,
        name: data.originCityName
      }),
      nog: data.nog,
      cargoComodity: new OptionsClass({
        name: data.cargoCommodity,
        code: data.cargoCommodityCode
      }),
      cargoProduct: data.cargoProduct,
      estTotalCargoVolumeWeight: data.totalEstCargoVolumeWeight,
      estTotalCargoGrossWeight: data.totalEstCargoGrossWeight,
      flightData: this.detailFlightsData,
      isFromRebookingRTC: data.isFromRtc,
      isUseSabre: data.isUseSabre,
      isOverCutoffTime: data.isOverCutoffTime,
      reasonFailed: data.reasonFailed,
      flightPlaneForECargo: data.flightPlaneForECargo,
      airportDestinationCode: data.airportDestinationCityCode,
      airportOriginCode: data.airportOriginCityCode,
      photoProof: data.photoProof,
      isAllowUseProof: data.isAllowUseProof
    });
    storeDatatoSessionStorage("cargo-input-data", newCargoInputData);

    // add bag number to localstorage
    const groupBaggingNumber = groupBy(data.detailStt, "baggingNumber");
    const dataBagging = [];
    for (const [key, value] of Object.entries(groupBaggingNumber)) {
      if (key) {
        dataBagging.push({
          baggingNumber: key,
          bagGrossWeight: value[0].bagCustomGrossWeight || null,
          isFromRebooking: true,
          stt: value
        });
      }
    }
    storeDatatoSessionStorage("cargo-bag", dataBagging);
    this.bagResult = dataBagging as any;

    this.initCalculateVolumeData = new CalculateVolume({
      chargeableWeight: data.currentChargeableWeight,
      calculateType: data.calculateType || CALCULATE_TYPE.INIT
    });
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.INIT_CALCULATE_TYPE,
      this.initCalculateVolumeData
    );
  }

  @Mutation
  private setLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }

  @Mutation
  private setLoadingCargoDispute (isLoading: boolean) {
    this.isLoadingCargoDispute = isLoading;
  }

  @Mutation
  private setLoadingPrint(isLoading: boolean) {
    this.isLoadingPrint = isLoading;
  }

  @Mutation
  public setErrorPrint(isLoading: boolean) {
    this.isErrorPrint = isLoading;
  }

  @Mutation
  public async setAdvanceFilterData(value: any) {
    this.advanceFilterData = value;
  }

  @Mutation
  public setSearch(val: string) {
    this.search = val;
  }

  @Mutation
  public setStartDate(val: any) {
    this.periodeStart = val;
  }

  @Mutation
  public setEndDate(val: any) {
    this.periodeEnd = val;
  }

  @Mutation
  public setOpenModalTopup(boolean: boolean) {
    this.isOpenModalTopup = boolean;
  }

  @Mutation
  public setError(boolean: boolean) {
    this.isError = boolean;
  }

  @Mutation
  public setErrorCause(str: string) {
    this.errorCause = str;
  }

  @Action
  async getRegionBaggingGrouping(code: string) {
    if (code) {
      try {
        this.setLoadingRegion(true);
        MainAppController.closeErrorMessage();
        const res = await BaggingController.getRegionBaggingGrouping(code);
        this.setRegionBaggingGrouping(res);
        this.setShowNotesDestination(true);
      } catch (error) {
        MainAppController.showErrorMessage(
          parsingErrorResponse(
            error,
            "Gagal Mendapatkan Region Bagging Grouping",
            () => this.getRegionBaggingGrouping(code)
          )
        );
        this.setShowNotesDestination(false);
      } finally {
        this.setLoadingRegion(false);
      }
    }
  }

  @Mutation
  private async setFirst() {
    this.pagination.page = 1;
    this.cargoData.pagination.page = 1;
    this.retryCargo.pagination.page = 1;
  }

  @Action
  public async setFirstPage() {
    await this.setFirst();
  }

  @Action
  public setDefaultFlightData() {
    this.form.airports = [];
    this.form.airportOrigin = {
      airportCode: "",
      airportName: "",
      cityCode: "",
      cityName: "",
      office: "",
      participantId: "",
      name: "",
      value: ""
    };
    this.form.airportDestination = {
      airportCode: "",
      airportName: "",
      cityCode: "",
      cityName: "",
      office: "",
      participantId: "",
      name: "",
      value: ""
    };
    this.form.flightsData = [];
  }

  @Action
  public mappingReadyToCargo() {
    if (
      this.readyToCargoDetail.id !== 0 &&
      this.readyToCargoDetail.detail.length &&
      !this.sourceSttFromLocalStorage.length
    ) {
      this.form.cargoProduct = this.readyToCargoDetail.rtcCargoProductType;

      this.setSTTResultFinal(this.readyToCargoDetail.detail);
      this.setSourceFromLocalStorage(this.readyToCargoDetail.detail);
      const groupBaggingNumber = groupBy(
        this.readyToCargoDetail.detail,
        "baggingNumber"
      );
      const data = [];
      for (const [key, value] of Object.entries(groupBaggingNumber)) {
        if (key) {
          data.push({
            baggingNumber: key,
            bagGrossWeight: value[0].bagCustomGrossWeight || null,
            stt: value
          });
        }
      }
      storeDatatoSessionStorage("cargo-bag", data);
      this.setBagResult(data);
    }
    this.setSTTResultFinal(this.groupedSTTResultFinal);
      const cargoInputForm = JSON.parse(
        getDataSessionStorage("cargo-input-data") || "{}"
      );

    cargoInputForm.cargoProduct = this.form.cargoProduct;

    if (this.form.flightsData.length > 0) {
      this.form.airportOrigin.airportCode =
        this.form.flightsData[0].airportCodeOrigin ||
        this.form.airports[0]?.airportCode ||
        this.form.airportOrigin.airportCode ||
        cargoInputForm.airportOrigin.airportCode;
      this.form.airportOrigin.value =
        this.form.flightsData[0].airportCodeOrigin ||
        this.form.airportOrigin.airportCode;
      this.form.airportDestination.airportCode =
        this.form.flightsData[this.form.flightsData.length - 1]
          .airportCodeDestination ||
        this.form.airports[this.form.airports.length - 1]?.airportCode ||
        this.form.airportDestination.airportCode ||
        cargoInputForm.airportDestination.airportCode;
      this.form.airportDestination.value =
        this.form.flightsData[this.form.flightsData.length - 1]
          .airportCodeDestination || this.form.airportDestination.airportCode;
      this.setIsOverCutOffTime(this.readyToCargoDetail.isMoreThanCutOffTime || cargoInputForm.isOverCutOffTime);
      // set airportCode to loalstorage
      cargoInputForm.airportOriginCode =
        this.form.flightsData[0].airportCodeOrigin ||
        this.form.airports[0]?.airportCode;
      cargoInputForm.airportDestinationCode =
        this.form.flightsData[this.form.flightsData.length - 1]
          .airportCodeDestination ||
        this.form.airports[this.form.airports.length - 1]?.airportCode;
      cargoInputForm.airportOrigin.airportCode = this.form.airportOrigin.airportCode;
      cargoInputForm.airportDestination.airportCode = this.form.airportDestination.airportCode;
      cargoInputForm.airportOrigin.value = this.form.airportOrigin.value;
      cargoInputForm.airportDestination.value = this.form.airportDestination.value;
      cargoInputForm.isOverCutOffTime = this.isOverCutOffTime;
      cargoInputForm.dimension = this.form.actualDimension;


      storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
    }
  }

  @Action
  public async autoFillDestination(detailSTT: any) {
    if (detailSTT) {
      if (!this.destinationCity?.code) {
        await this.getCityList(detailSTT);
        if (!this.regionBaggingGrouping.baggingRegionDestinationId) {
          this.getRegionBaggingGrouping(this.destinationCity?.code);
        }
      }
    }
  }

  @Action
  async getCityList(detailSTT: any) {
    const region = detailSTT.regionId || detailSTT.region_id;
    const destinationCityCode =
      detailSTT.destination_city_code || detailSTT.destinationCityCode;
    await LocationController.getCityList({
      search:
        this.dataProfile.account_location.city_code === region ||
        this.regionBaggingGrouping.baggingRegionOriginId === region
          ? destinationCityCode
          : region ?? destinationCityCode,
      status: "",
      page: 1,
      limit: 10
    });
    this.setDestinationCity(
      region || destinationCityCode ? this.optionDestinationCity[0] : ""
    );
  }

  @Action
  public mappingCommodityOptions() {
    this.setDisableCommodityGroup(false);

    // mapping each bagging's stt
    let mappingdata: CargoDetailStt[] = [];
    for (const item of this.sttResultFinal as any) {
      if (item?.sttDetails?.length) {
        for (const detail of item.sttDetails) {
          mappingdata.push(detail);
        }
      } else {
        mappingdata.push(item);
      }
    }

    // filter result of mapping data by commodity group
    let getUniqueList: any = uniqBy(
      mappingdata.filter((item: CargoDetailStt) => item.commodityGroupCode),
      "commodityGroupCode"
    );
    // get all commodity group even dg or non dg
    const getUniqueListAll: any = cloneDeep(getUniqueList);

    // filter result of mapping data by dg commodity group
    const dgDataFiltered = mappingdata.filter(
      (item: CargoDetailStt) => item.commodityGroupIsDg
    );
    if (dgDataFiltered.length) {
      mappingdata = dgDataFiltered;
      getUniqueList = uniqBy(
        dgDataFiltered.filter(
          (item: CargoDetailStt) => item.commodityGroupCode
        ),
        "commodityGroupCode"
      );
    }

    // count total duplicate commodity group
    const countGroupByCommodity = mappingdata.reduce(
      (accumulator: any, item: CargoDetailStt) => {
        return (
          (accumulator[item.commodityGroupName] =
            (accumulator[item.commodityGroupName] || 0) + 1),
          accumulator
        );
      },
      {}
    );

    // convert object total to array of object
    const totalDataByCommodityGroup = Object.entries(
      countGroupByCommodity
    ).map((item: any[]) => ({ name: item[0], total: item[1] }));

    // find max of total
    const max = totalDataByCommodityGroup.reduce((prev: any, current: any) =>
      prev.total > current.total ? prev : current
    );

    // find all index if possible max is more than 1
    const maxIndexLocation = totalDataByCommodityGroup.reduce(
      (accumulator: any, currentValue, currentIndex) =>
        currentValue.total === max.total
          ? accumulator.concat(currentIndex)
          : accumulator,
      []
    );

    const commodityList = getUniqueListAll.map(
      (item: CargoDetailStt) =>
        new OptionsClass({
          name: item.commodityGroupName,
          value: item.commodityGroupCode,
          shcCode: item.shcCode,
          shcName: item.shcName
        })
    );

    // if only one max, will set default value
    if (maxIndexLocation.length === 1) {
      // get detail data of max
      const dominanData: CargoDetailStt = getUniqueList[maxIndexLocation[0]];

      // set to default value
      this.setCommodityItem(
        new OptionsClass({
          name: dominanData.commodityGroupName,
          code: dominanData.commodityGroupCode,
          shcCode: dominanData?.shcCode,
          shcName: dominanData?.shcName
        })
      );
      this.form.cargoCommodityName = dominanData.commodityGroupName;
      this.form.cargoCommodityCode = dominanData.commodityGroupCode || "";
      this.form.shcName = dominanData?.shcName || "";
      this.form.shcCode = dominanData?.shcCode || "";
      this.setDisableCommodityGroup(true);
    }
    // if more than one max, will be empty and user select commodity
    else {
      const cargoInputForm = JSON.parse(
        getDataSessionStorage("cargo-input-data") || "{}"
      );

      if (!cargoInputForm.cargoComodity?.name) {
        this.setCommodityItem(new OptionsClass());
        this.form.cargoCommodityName = "";
        this.form.cargoCommodityCode = "";
        this.form.shcName = "";
        this.form.shcCode = "";
      }

      let defaultCommodity = new OptionsClass(commodityList[0]);

      // default commodity group = first dg ifhave dg but dominan is draw even dominan is non dg
      if (dgDataFiltered.length) {
        const commodityListDg = getUniqueList.map(
          (item: CargoDetailStt) =>
            new OptionsClass({
              name: item.commodityGroupName,
              value: item.commodityGroupCode,
              shcCode: item.shcCode,
              shcName: item.shcName
            })
        );
        defaultCommodity = commodityListDg[0];
      }

      // if no dominan (draw) total
      this.setCommodityItem(
        new OptionsClass({
          name: defaultCommodity.name,
          code: defaultCommodity.value,
          shcCode: defaultCommodity.shcCode,
          shcName: defaultCommodity.shcName
        })
      );
      this.form.cargoCommodityCode = defaultCommodity.value;
      this.form.cargoCommodityName = defaultCommodity.name;
      this.form.shcName = defaultCommodity.shcName || "";
      this.form.shcCode = defaultCommodity.shcCode || "";
    }

    this.setCommodityOptions(commodityList);
  }

  // flag minimum weight cargo
  private minimumWeight = FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue();
  private volumeWeightFlag = this.minimumWeight !== 0;
  @Action
  calculationVolumeWeight(totalPcs: number) {
    const divider = getConfigDimensionDivider(this.form.cargoType);
    const total =
      ((this.form.actualDimension.length *
        this.form.actualDimension.width *
        this.form.actualDimension.height) /
        divider) *
      totalPcs;
    const cargoVolumeWeight = total < 1 ? "1" : Math.round(total).toString();
    const cargoVolumeWeightFlag =
        this.volumeWeightFlag
        ? Number(cargoVolumeWeight) < Number(this.minimumWeight)
          ? this.minimumWeight.toString()
          : cargoVolumeWeight
        : cargoVolumeWeight;
    this.form.actualTotalCargoVolumeWeight = cargoVolumeWeightFlag;
    const totalActualCargoVolumeWeight = Number(
      this.form.actualTotalCargoVolumeWeight
    );
    this.setOnChangeTotalCargoVolumeWeight(totalActualCargoVolumeWeight);
  }

  @Mutation
  public setPeriodeStart(value: Date | null) {
    this.periodeStart = value;
  }

  @Mutation
  public setDestinationCity(value: any) {
    if (value) {
      this.form.destinationCityName = value?.name || "";
      this.form.destinationCityCode = value?.code || "";

      const destination = new DestinationCityData({
        id: value.id,
        code: value.code,
        name: value.name,
        label: `${value.code} - ${value.name}`
      });
      const cargoInputForm: CargoInputData = JSON.parse(
        getDataSessionStorage("cargo-input-data") || "{}"
      );
      cargoInputForm.destinationCityData = destination;
      storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
    }
    this.destinationCity = value;
  }

  @Mutation
  public setResetDestinationCity() {
    this.destinationCity = "";
    this.form.destinationCityCode = "";
    this.form.destinationCityName = "";
  }

  @Mutation
  public setPeriodeEnd(value: Date | null) {
    this.periodeEnd = value;
  }

  @Mutation
  public setSttFailed(val: any[]) {
    this.sttFailed = val;
  }

  @Mutation
  public setFailed(val: boolean) {
    this.isFailed = val;
  }

  @Mutation
  public setLoadingAirport(val: boolean) {
    this.isLoadingAirport = val;
  }

  @Mutation
  public setOpenSuccess(val: boolean) {
    this.isOpenSuccess = val;
  }

  @Mutation
  public setFullBooked(val: boolean) {
    this.isFullBooked = val;
  }

  public showSelectAirport = false;

  @Mutation
  public setShowSelectAirport(bool: boolean) {
    this.showSelectAirport = bool;
  }

  @Mutation
  public setShowSelectAirportToLocalStorage(bool: boolean) {
    this.showSelectAirportFromLocalStorage = bool;
    storeDatatoSessionStorage("show-select-airport", bool);
  }

  @Mutation
  public setCargoType(value: any) {
    this.cargoType = {
      type: value.type,
      status: value.status
    };
    this.form.cargoType = value.type;
    this.form.cargoTypeStatus = value.status;
    storeDatatoSessionStorage("cargo-type", value);
  }

  @Mutation
  public setSourceFromLocalStorage(data: CargoDetailStt[]) {
    this.sourceSttFromLocalStorage = data;
  }

  @Mutation
  public setListLastReadCargo(data: ListLastReadCargo[]) {
    this.listLastReadCargo = data;
  }

  @Mutation
  public setProgressValue(value: number) {
    this.progressValue = value;
    storeDatatoSessionStorage("progress-value", value);
  }

  @Mutation
  public setIsModalGamification(value: boolean) {
    this.isShowModalGamification = value;
    storeDatatoSessionStorage("is-modal-gamification", value);
  }

  @Mutation
  public setIsModalGamificationDone(value: boolean) {
    this.isModalGamificationDone = value;
    storeDatatoSessionStorage("is-modal-gamification-done", value);
  }

  @Mutation
  public setIsChangeVolumeActual(value: boolean) {
    this.isChangeVolumeActual = value;
    storeDatatoSessionStorage("is-change-total-actual-volume", value);
  }
  @Mutation
  public setIsFromRTC(value: boolean) {
    this.isFromRtc = value;
  }

  @Mutation
  public setTimestampBooking(value: number) {
    this.timestampBooking = value;
  }

  @Mutation
  public setLoadingRegion(data: boolean) {
    this.loadingRegion = data;
  }

  @Mutation
  public setShowNotesDestination(data: boolean) {
    this.showNotesDestination = data;
  }

  @Mutation
  public setRegionBaggingGrouping(data: RegionBaggingGrouping) {
    this.regionBaggingGrouping = data;
  }

  @Mutation
  public setCargoStatus(value: string) {
    this.cargoStatus = value;
  }

  @Mutation
  public setCancelFromDetail(boolean: boolean) {
    this.cancelFromDetail = boolean;
  }

  @Mutation
  public setDeleteFromDetail(boolean: boolean) {
    this.deleteFromDetail = boolean;
  }

  @Mutation
  public setCacheCommodityGroup(boolean: boolean) {
    this.isCacheCommodityGroup = boolean;
  }

  @Mutation
  public setDestinationCityRTC(param: any) {
    this.destinationCityRTC = param;
  }

  @Mutation
  public setClientValue(param: any) {
    this.clientValue = param;
  }

  @Mutation
  public setReadyToCargoList(param: ReadyToCargoListEntities) {
    this.readyToCargoList = param;
  }

  @Mutation
  public setActiveTabs(param: string) {
    this.activeTabs = param;
  }

  @Mutation
  public setCargoInputForm(obj: CargoInputData) {
    this.cargoInputForm = obj;
    this.CargoInputData = obj;
  }

  @Action
  public setTotalActualGrossWeight(value: number) {
    const cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    const _country = AccountController.accountData?.countryCode ?? "ID";
    cargoInputForm.totalActualCargoGrossWeight = parseByCountry(value.toString(), { country: _country });
    cargoInputForm.calcuateActualCargoGrossWeight = parseByCountry(value.toString(), { country: _country }); // explanation https://github.com/Lionparcel/medusa/pull/5753/files#r1285584448
    this.CargoInputData.totalActualCargoGrossWeight = parseByCountry(value.toString(), { country: _country });
    this.form.actualTotalCargoGrossWeight = value.toString();
    storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
  }

  @Mutation
  public setOnChangeTotalActualGrossWeight(value: number) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    const _country = AccountController.accountData?.countryCode ?? "ID";
    this.cargoInputForm.totalActualCargoGrossWeight = parseByCountry(value.toString(), { country: _country });
    this.form.actualTotalCargoGrossWeight = value.toString();
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    this.isErrorInputStepThree.grossWeight = !parseByCountry(this.form.actualTotalCargoGrossWeight, { country: _country });
  }

  @Mutation
  public setOnChangeThresholdTime(value: number) {
    storeDatatoSessionStorage("is-change-threshold-time", true);
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.thresholdTime = parseByCountry(value.toString(), { country: AccountController.accountData?.countryCode ?? "ID" });
    this.form.thresholdTime = value;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setOnChangeDimension({ length, width, height }: DimensionData) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.dimension = new DimensionData({
      length: length,
      width: width,
      height: height
    });
    this.form.actualDimension.height = height;
    this.form.actualDimension.length = length;
    this.form.actualDimension.width = width;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    this.isErrorInputStepThree.dimension = !this.form.actualDimension.width || !this.form.actualDimension.length || !this.form.actualDimension.height;
  }

  @Mutation
  public setOnChangeTotalColi(value: number) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.totalActualCargoColi = Number(value);
    this.form.actualTotalSTTPieces = value;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    this.isErrorInputStepThree.totalPieces = !+this.form.actualTotalSTTPieces;
    // if (
    //   +this.formDetailPieces.totalPieces !== +this.form.actualTotalSTTPieces &&
    //   this.isHaveBeenSubmitDetailPieces
    // ) {
    //   this.isErrorDiffPiecesActualThanDimensionPieces = true;
    //   return;
    // }
    this.isErrorDiffPiecesActualThanDimensionPieces = false;
  }

  @Mutation
  public resetTotalColiOnLocalStorage() {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.totalActualCargoColi = 0;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setOnChangeTotalCargoVolumeWeight(value: number) {
    const volumeWeight = Math.max(1, value);

    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    const _country = AccountController.accountData?.countryCode ?? "ID";
    this.cargoInputForm.totalActualCargoVolumeWeight = parseByCountry(volumeWeight.toString(), { country: _country });
    this.CargoInputData.totalActualCargoVolumeWeight = parseByCountry(volumeWeight.toString(), { country: _country });
    this.cargoDetailData.totalActualCargoVolumeWeight = parseByCountry(volumeWeight.toString(), { country: _country });
    this.form.actualTotalCargoVolumeWeight = volumeWeight.toString();
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
    this.isErrorInputStepThree.volumeWeight = !parseByCountry(this.form.actualTotalCargoVolumeWeight, { country: _country });
  }

  @Mutation
  public resetErrorDiffPiecesActualThanDimensionPieces() {
    this.isErrorDiffPiecesActualThanDimensionPieces = false;
  }

  get errorInputStepThree() {
    let result = false;
    Object.entries(this.isErrorInputStepThree).forEach(([, value]) => {
      if (value) {
        result = value;
      }
    });
    return result;
  }

  @Mutation
  public setResetErrorInputStepThree() {
    this.isErrorInputStepThree = {
      grossWeight: false,
      dimension: false,
      totalPieces: false,
      volumeWeight: false
    };
  }

  @Mutation
  public setCargoComodity(value: OptionsClass) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );

    this.cargoInputForm.cargoComodity.name = value?.name ?? "";
    this.cargoInputForm.cargoComodity.code = value.code || value.value || "";
    this.cargoInputForm.cargoComodity.shcCode = value.shcCode || "";
    this.cargoInputForm.cargoComodity.shcName = value.shcName || "";
    this.form.cargoCommodityName = value.name ?? "";
    this.form.cargoCommodityCode = value.code || value.value || "";
    this.form.shcName = value.shcName || "";
    this.form.shcCode = value.shcCode || "";
    this.commodityItem = new OptionsClass({
      name: value.name ?? "",
      code: value.code || value.value || "",
      shcName: value.shcName || "",
      shcCode: value.shcCode || ""
    });
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setDisableCommodityGroup(value: boolean) {
    this.disableCommodityGroup = value;
  }

  @Mutation
  public setOnChangeNog(value: string) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.nog = value;
    this.form.nog = value;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setOnSelectCargoProduct(value: string) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.cargoProduct = value;
    this.CargoInputData.cargoProduct = value;
    this.form.cargoProduct = value;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setOnChangeVehicleNumber(value: string) {
    const cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    cargoInputForm.vehicleNumber = value;
    this.CargoInputData.vehicleNumber = value;
    this.form.vehicleNumber = value;
    storeDatatoSessionStorage("cargo-input-data", cargoInputForm);
  }

  @Mutation
  public setIsChangeCargoType(value: boolean) {
    this.isChangeCargoType = value;
    storeDatatoSessionStorage("cargo-is-change-cargo-type", value);
  }

  @Mutation
  public setUpdateFromBookingCargoNumber(value: string) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.cargoNumber = value;
    this.form.cargoNumber = value;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setEstimationTotalVolumeWeight(value: any) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.estTotalCargoVolumeWeight = parseByCountry(value.toString(), { country: AccountController.accountData?.countryCode ?? "ID" });
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setEstimationTotalGrossWeight(value: any) {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.estTotalCargoGrossWeight = parseByCountry(value.toString(), { country: AccountController.accountData?.countryCode ?? "ID" });
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public setFlightData(value: FlightDetail) {
    const detailFlightsData = JSON.parse(
      getDataSessionStorage("rtc-flights-data") || "[]"
    );
    detailFlightsData.push(value);
    this.form.flightsData.push(value);
    storeDatatoSessionStorage("rtc-flights-data", detailFlightsData);
  }

  @Mutation
  public setEditFlightData(value: FlightDetail[]) {
    storeDatatoSessionStorage("rtc-flights-data", value);
  }

  @Mutation
  public resetFlightData() {
    this.form.flightsData.length = 0;
    storeDatatoSessionStorage("rtc-flights-data", []);
  }

  @Mutation
  public resetCargoInputForm(obj: CargoInputData) {
    storeDatatoSessionStorage("cargo-input-data", obj);
    this.cargoInputForm = obj;
    this.form.actualTotalCargoVolumeWeight = "0";
    this.form.destinationCityName = "";
    this.form.destinationCityCode = "";
    this.form.vehicleNumber = "";
    this.form.cargoProduct = "";
    this.form.cargoNumber = "";
    this.form.actualDimension = {
      length: obj.dimension.length,
      width: obj.dimension.width,
      height: obj.dimension.height
    };
    this.destinationCity = "";
    this.calculateTotalGrossWeight = 0;
    this.cargoInputForm = obj;
    this.CargoInputData = obj;
    this.isFillForm = false;
    this.cargoType = {};
  }

  @Mutation
  public resetTotalActualGrossWeight() {
    this.cargoInputForm = JSON.parse(
      getDataSessionStorage("cargo-input-data") || "{}"
    );
    this.cargoInputForm.totalActualCargoGrossWeight = 0;
    this.CargoInputData.totalActualCargoVolumeWeight = 0;
    this.form.actualTotalCargoGrossWeight = "0";
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  public resetIsEditReadyToCargo() {
    this.isEditReadyToCargo = false;
  }

  @Mutation
  public setShowModalCargoType(value: boolean) {
    this.showModalCargoType = value;
    storeDatatoSessionStorage("show-modal-cargo", value);
  }

  @Mutation
  public setFormDetailPieces(form: any) {
    const newForm = {
      totalPieces: form.totalPieces,
      dimensionPieces: form.dimensionPieces.map((pieces: any) => ({
        ...pieces,
        grossWeight: convertMinimumRounding(pieces.grossWeight, 0.10, 2, false),
        length: Number(formatInputNoDecimal(String(pieces.length))),
        width: Number(formatInputNoDecimal(String(pieces.width))),
        height: Number(formatInputNoDecimal(String(pieces.height))),
        volumeWeight: convertMinimumRounding(pieces.volumeWeight, 1)
      }))
    }
    this.formDetailPieces = newForm;
  }

  @Mutation
  public setShowPopupDimensionPieces(value: boolean) {
    this.showPopupDimensionPieces = value;
  }

  @Mutation
  public setIsEditReadyToCargo(value: boolean) {
    this.isEditReadyToCargo = value;
    storeDatatoSessionStorage("isEditReadyToCargo", value);
  }

  @Mutation
  public setPlaneAutoFlow(value: boolean) {
    this.isPlaneAutoFlow = value;
  }

  @Mutation
  public setCommodityItem(value: OptionsClass) {
    this.commodityItem = value;
  }

  @Mutation
  public setCommodityOptions(value: OptionsClass[]) {
    this.commodityOptions = value;
  }

  withPrintCutOff = false;
  withPrintCutOffLabel = false;

  @Mutation
  public setWithPrintCutOff(value: boolean) {
    this.withPrintCutOff = value;
  }

  @Mutation
  public setWithPrintLabelCutOff(value: boolean) {
    this.withPrintCutOffLabel = value;
  }

  @Mutation
  public setLastReadCargoSession(value: any) {
    this.lastReadCargoSession = value;
    storeDatatoSessionStorage("last-read-cargo", value);
  }

  @Mutation
  public setIsFromRebookingRTC(value: boolean) {
    this.isRebookingFromRTC = value;
    storeDatatoSessionStorage("is-from-rebooking-rtc", value);
  }

  get readyToCargoDetail() {
    return ReadyToCargoController.readyToCargoDetail;
  }

  get optionDestinationCity() {
    return LocationController.cityData.cityData.map(
      item =>
        new OptionsClass({
          id: item.id,
          label: `${item.code} - ${firstCapitalize(item.name?.toLowerCase())}`,
          code: item.code,
          name: capitalize(item.name?.toLowerCase())
        })
    );
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  get totalSttPieces() {
    // STTs with the same bagNo counted as one, STTs without bagNo counted per totalPieces
    return this.sttResultFinal
      .map((key: any) =>
        key.baggingNumber && key.sttDetails.length ? 1 : key.totalPieces
      )
      .reduce((a, b) => a + b, 0);
  }

  get isPlaneAuto() {
    return (
      this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto"
    );
  }

  get totalSttGrossWeight() {
    return this.sttResultFinal.reduce((acc, curr: any) => {
      if (curr.bagData.bagCustomGrossWeight) {
        return (
          acc +
          (curr.sttDetails.reduce(
            (sttAcc: any, sttCurr: CargoDetailStt) => sttAcc + (sttCurr.grossWeight || sttCurr.grossWeigth || 0),
            0
          ) || 0)
        );
      }

      return acc + (curr.grossWeigth || curr.grossWeight || 0);
    }, 0);
  }

  get totalSttVolumeWeight() {
    return this.sttResultFinal.reduce((acc, curr: any) => {
      if (curr.bagData.isUseNewCalculation || curr.baggingNumber) {
        return (
          acc +
          (curr.sttDetails.reduce(
            (sttAcc: any, sttCurr: CargoDetailStt) => sttAcc + (sttCurr.volumeWeight || 0),
            0
          ) || 0)
        );
      }

      return acc + (curr.volumeWeight || 0);
    }, 0);
  }

  get totalSttChargeableWeight() {
    const data = this.sttResultFinal.filter(
      (item: CargoDetailStt) => item.action !== "remove"
    );

    return data.length
      ? Math.max(1, this.totalSttGrossWeight, this.totalSttVolumeWeight)
      : 0;
  }

  get totalNewCalculationGrossWeights() {
    const data = this.sttResultFinal.filter(
      (item: CargoDetailStt) => item.action !== "remove"
    );
    return data.reduce((total, item: CargoDetailStt) => {
      if (item.bagData.bagCustomGrossWeight) {
        return total + item.bagData.bagCustomGrossWeight;
      }
      return total + item.grossWeigth;
    }, 0);
  }

  get totalNewCalculationVolumeWeights() {
    const data = this.sttResultFinal.filter(
      (item: CargoDetailStt) => item.action !== "remove"
    );
    return data.reduce((total, item: any) => {
      if (item.bagData?.bagCustomGrossWeight) { // untuk membedakan bag dan stt
        return (
          total +
          (item.sttDetails[0].bagData.bagCustomVolumeWeight ||
            item.sttDetails[0].bagCustomVolumeWeight)
        );
      }
      return total + item.volumeWeight;
    }, 0);
  }

  get totalGrossWeights() {
    const seen = new Map();
    const data: CargoDetailStt[] = [];

    for (const item of this.sourceSttFromLocalStorage) {
      const { baggingNumber } = item;

      if (!baggingNumber) {
        data.push(item);
        continue;
      }

      if (!seen.has(baggingNumber)) {
        const entry = { ...item, sttDetails: [item] };
        data.push(entry);
        seen.set(baggingNumber, entry);
      } else {
        // Deep reference, so the existing entry will be updated in seen and data
        seen.get(baggingNumber).sttDetails.push(item);
      }
    }

    const rawTotal = data
      .map((key: any) => {
        if (key.baggingNumber && key.bagData?.bagCustomGrossWeight) {
          return new CargoDetailBagData(key.bagData).bagCustomGrossWeight;
        } else {
          return key.grossWeigth;
        }
      })
      .reduce((a, b) => {
        return a + b;
      }, 0);
    if (!this.isPlaneAuto) {
      this.form["estTotalCargoGrossWeight"] = formatByCountry(rawTotal, { type: "weight", country: AccountController.accountData?.countryCode ?? "ID" });
    }
    return rawTotal;
  }

  isFromCutOff = false;
  @Mutation
  public setIsFromCutOff(boolean: boolean) {
    this.isFromCutOff = boolean;
  }

  @Mutation
  public setIsBookingAuto(bool: boolean): void {
    this.isBookingAuto = bool;
  }

  @Mutation
  public setIsOverCutOffTime(bool: boolean): void {
    this.isOverCutOffTime = bool;
  }

  @Action
  public resetCargoData() {
    this.setCargoDetailData(new CargoData());
    storeDatatoSessionStorage("cargo", []);
    storeDatatoSessionStorage("cargo-bag", []);
    storeDatatoSessionStorage("event-name", "");
    storeDatatoSessionStorage("rtc-flights-data", []);
    storeDatatoSessionStorage("next-rtc-flights-data", []);
    storeDatatoSessionStorage("calculate-flight-date", []);
    storeDatatoSessionStorage("show-select-airport", false);
    storeDatatoSessionStorage("cargo-type", {});
    storeDatatoSessionStorage("fill-form", false);
    storeDatatoSessionStorage("error-awb", "");
    storeDatatoSessionStorage("isEditReadyToCargo", false);
    storeDatatoSessionStorage("error-awb", "");
    storeDatatoSessionStorage("setShowPlaneSchedule", false);
    storeDatatoSessionStorage("is-modal-gamification", false);
    storeDatatoSessionStorage("is-from-rebooking-rtc", false);
    storeDatatoSessionStorage("is-change-threshold-time", false);
    storeDatatoSessionStorage("is-delete-stt", false);
    storeDatatoSessionStorage("is-change-total-actual-volume", false);
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY,
      false
    );
    this.setDimensionPerKoliData(new DimensionPerKoliData());
    this.setIsDimensionSaved(false);
    this.setIsSttUpdated(false);
    this.setIsAwbValid(false);
    this.setSTTResultFinal([]);
    this.setBagResult([]);
    this.setSourceFromLocalStorage([]);
    ReadyToCargoController.setCalculateFlightDate([]);
    ReadyToCargoController.setDetailFlightData([]);
    ReadyToCargoController.setDetailNextFlightData([]);
    this.setNotificationWeight(false);
    this.setResetDestinationCity();
    this.resetTotalActualGrossWeight();
    this.resetCargoInputForm(new CargoInputData());
    this.setShowModalCargoType(false);
    NGenController.setErrorAwb("");
    this.setShowSelectAirportToLocalStorage(false);
    this.resetIsEditReadyToCargo();
    ReadyToCargoController.setReadyToCargoDetail(new ReadyToCargo());
    this.resetForm();
    this.setHaveBeenSubmit(false);
    this.setFormDetailPieces({
      totalPieces: 0,
      dimensionPieces: [
        {
          pieces: 0,
          length: 30,
          width: 20,
          height: 10,
          grossWeight: 1
        }
      ]
    });
    this.setDestinationCityRTC("");
    this.setIsChangeVolumeActual(false);
    this.setClientValue("");
    this.setSearchFlight([])
    this.resetScanFailedList();
  }

  @Mutation
  public resetFormDataFlight() {
    storeDatatoSessionStorage("rtc-flights-data", []);
    this.form.flightsData = [];
  }

  @Mutation
  public setErrorMaxGrossWeight(val: boolean) {
    this.isErrorMaxGrossWeight = val;
  }

  @Mutation
  public setErrorMaxVolumeWeight(val: boolean) {
    this.isErrorMaxVolumeWeight = val;
  }

  @Mutation
  public setErrorMaxPieces(val: boolean) {
    this.isErrorMaxPieces = val;
  }

  get totalVolumeWeights() {
    const rawTotal = this.sourceSttFromLocalStorage
      .map((key: any) => {
        if (key.baggingNumber && key.sttDetails) {
          return key.sttDetails.reduce((a: any, b: any) => {
            return a + b.volumeWeight;
          }, 0);
        } else {
          return key.volumeWeight;
        }
      })
      .reduce((a, b) => {
        return a + b;
      }, 0);
    if (!this.isPlaneAuto) {
      this.form["estTotalCargoVolumeWeight"] = formatByCountry(rawTotal, { type: "weight", country: AccountController.accountData?.countryCode ?? "ID" });
    }
    return rawTotal;
  }

  get groupedSTTResultFinal() {
    const tempData: any = [];
    if (this.sourceSttFromLocalStorage) {
      this.sourceSttFromLocalStorage.forEach((e: any) => {
        const existingIdx = tempData.findIndex(
          (a: any) => a.baggingNumber === e.baggingNumber
        );
        if (e.baggingNumber && !e.sttDetails) {
          if (existingIdx > -1) {
            tempData[existingIdx]["sttDetails"].push(e);
          } else {
            tempData.push({ ...e, sttDetails: [e] });
          }
          return;
        }
        tempData.push(e);
      });
    }
    return tempData;
  }

  get dimensionDivider() {
    return getConfigDimensionDivider("plane");
  }

  get isAllowEditCutoff() {
    const isEditRtcCutoff =
      ReadyToCargoController.flowBooking === "rtc-edit" &&
      this.cutOffTime.hours !== undefined &&
      this.cutOffTime.minutes !== undefined;
    return isEditRtcCutoff;
  }

  get cutOffTime() {
    return {
      hours: ReadyToCargoController.readyToCargoDetail.cutOffTime?.split(
        ":"
      )[0],
      minutes: ReadyToCargoController.readyToCargoDetail.cutOffTime?.split(
        ":"
      )[1]
    };
  }

  @Action
  public getSearchFlight(params: {
    departureDate: string;
    originCityCode: string;
    originAirportCode: string;
    destinationAirportCode: string;
    actualTotalGrossWeight: number;
    actualTotalVolumeWeight: number;
    thresholdTime: number;
    commodityGroupCode: string
  }) {
    this.setLoadingSearchFlight(true)
    this.setErrorCauseSearchFlight("");
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .searchFlight(
        new SearchFlightRequest(
          params.departureDate,
          params.originCityCode,
          params.originAirportCode,
          params.destinationAirportCode,
          params.actualTotalGrossWeight,
          params.actualTotalVolumeWeight,
          params.thresholdTime,
          params.commodityGroupCode
        )
      )
      .then((res: SearchFlight[]) => {
        this.setSearchFlight(res);
        return true;
      })
      .catch(error => {
        if (error.response?.status === 404) {
          this.setSearchFlight([]);
        } else {
          this.setErrorCauseSearchFlight(error.response ?  "server" : "internet");
        }
      })
      .finally(() => {
        this.setLoadingSearchFlight(false)
      });
  }

  @Action
  public checkAvailable(
    payload: CheckAvailableRequest
  ): Promise<FlightAvailable> {
    const presenter = container.resolve(CargoPresenter);
    return presenter.checkAvailable(payload);
  }

  @Action
  async getAwbValidation(
    payload: AwbValidationApiRequest
  ): Promise<AwbDetailData> {
    return container.resolve(CargoPresenter).getAwbValidation(payload);
  }

  calculateVolumeData = new CalculateVolume(
    JSON.parse(
      getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_VOLUME) || "{}"
    )
  );
  initCalculateVolumeData = new CalculateVolume(
    JSON.parse(
      getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.INIT_CALCULATE_TYPE) ||
        "{}"
    )
  );
  isLoadingCalculateVolume = false;

  @Mutation
  public setIsLoadingCalculateVolume(bool = false) {
    this.isLoadingCalculateVolume = bool;
  }

  @Mutation
  public setCalculateVolumeData(value = new CalculateVolume()) {
    if ([CALCULATE_TYPE.INIT].includes(value.calculateType)) this.isDimensionChanged = false;
    this.calculateVolumeData = value;
    this.calculateType = value.calculateType;
    storeDatatoSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_TYPE, value.calculateType);
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.CALCULATE_VOLUME,
      value
    );
  }

  @Mutation
  public setInitCalculateVolumeData(value = new CalculateVolume()) {
    this.initCalculateVolumeData = value;
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.INIT_CALCULATE_TYPE,
      value
    );
  }

  calculateVolumeApiController = new AbortController();
  @Mutation
  public setCalculateVolumeApiController(value = new AbortController()) {
    this.calculateVolumeApiController = value;
  }

  public calculateType: string = JSON.parse(getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_TYPE) || "{}");

  @Mutation
  public setCalculateType(type = "") {
    this.calculateType = type;
    storeDatatoSessionStorage(SESSION_STORAGE_CARGO_KEY.CALCULATE_TYPE, type);
  }

  isCargoDimensionOn = false;

  @Mutation
  setIsCargoDimensionOn(bool = false) {
    if (bool) this.calculateVolumeData.isUploadProofPhoto = false;
    this.isCargoDimensionOn = bool;
  }

  @Action
  async calculateVolume(payload: CalculateVolumeApiRequest): Promise<void> {
    const currentController = new AbortController();
    try {
      this.setIsLoadingCalculateVolume(true);
      this.calculateVolumeApiController?.abort();
      this.setCalculateVolumeApiController(currentController);

      if (payload.calculateType === "INIT") {
        this.setOnChangeDimension({
          length: payload.calculateRequest.length,
          width: payload.calculateRequest.width,
          height: Math.max(1,payload.calculateRequest.height),
        })
        this.setInitCalculateVolumeData();
      }

      const isMinimumVolumePerPiece = getConfigIsminimumVolumePerPiece(
        payload.calculateRequest.cargoType,
        payload.calculateRequest.cargoType === "plane"
          ? this.form.cargoTypeStatus
          : ""
      );

      const res = await container.resolve(CargoPresenter).calculateVolume(
        new CalculateVolumeApiRequest({
          ...payload,
          calculateRequest: new CalculateVolumeRequest({
            ...payload.calculateRequest,
            totalStt: this.totalSttOutsideBag,
            maxDisputeWeight: this.maxDisputeWeight,
            currentChargeableWeight: isMinimumVolumePerPiece
              ? this.initCalculateVolumeData.chargeableWeight
              : payload.calculateRequest.chargeableWeightReweigh
          }),
          signal: currentController.signal
        })
      );

      const isInit = payload.calculateType === CALCULATE_TYPE.INIT;
      const isChangeModa =
        payload.calculateType === CALCULATE_TYPE.CHANGE_MODA;

      this.setCalculateVolumeData(
        new CalculateVolume({ ...res, calculateType: payload.calculateType })
      );
      this.mappingCalculateVolume();

      const shouldUpdateInitData = isInit || isChangeModa;

      if (shouldUpdateInitData) {
        this.setInitCalculateVolumeData(
          new CalculateVolume({
            ...this.initCalculateVolumeData,
            ...res,
            calculateType: payload.calculateType,
            chargeableWeight: isMinimumVolumePerPiece
              ? res.chargeableWeight
              : payload.calculateRequest.chargeableWeightReweigh
          })
        );
      }
    } catch (error) {
      if ((error as any)?.code === "ERR_CANCELED") return
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          "Kalkulasi Berat Volume Gagal!",
          () => {
            MainAppController.closeErrorMessage();
            this.calculateVolume(payload);
          },
          () => {
            MainAppController.closeErrorMessage();
            this.calculateVolume(payload);
          },
        ));
    } finally {
      if (this.calculateVolumeApiController === currentController) {
        this.setIsLoadingCalculateVolume(false);
      }
    }
  }

  public isUploadProofPhoto: boolean =
    getDataSessionStorage(SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY) ===
    "true";

  @Mutation
  public setUploadProofPhoto(value: boolean) {
    this.isUploadProofPhoto = value;
    storeDatatoSessionStorage(
      SESSION_STORAGE_CARGO_KEY.UPLOAD_PROOF_PHOTO_KEY,
      value
    );
  }

  @Action
  public mappingCalculateVolume() {
    this.setOnChangeDimension({
      height: this.calculateVolumeData.height,
      length: this.form.actualDimension.length,
      width: this.form.actualDimension.width
    })

    this.setOnChangeTotalCargoVolumeWeight(
      Math.max(1, this.calculateVolumeData.volumeWeight)
    );

    this.setUploadProofPhoto(this.calculateVolumeData.isUploadProofPhoto);
  }

  @Mutation
  private setSearchFlight(data: SearchFlight[]) {
    this.searchFlight = data;
  }

  @Mutation
  public setErrorCauseSearchFlight(err: string) {
    this.errorCauseSearchFlight = err;
  }

  @Mutation
  public setLoadingSearchFlight(status: boolean) {
    this.isLoadingSearchFlight = status;
  }

  @Mutation
  setDimensionPerKoliData(data: DimensionPerKoliData) { 
    const updatedData = {
      ...data,
      dimensionPieces: data.dimensionPieces.map(piece => ({
        ...piece,
        sttPieceLength: Number(formatInputNoDecimal(String(piece.sttPieceLength))),
        sttPieceWidth: Number(formatInputNoDecimal(String(piece.sttPieceWidth))),
        sttPieceHeight: Number(formatInputNoDecimal(String(piece.sttPieceHeight))),
        sttPieceVolumeWeight: convertMinimumRounding(piece.sttPieceVolumeWeight, 1),
        sttPieceGrossWeight: convertMinimumRounding(piece.sttPieceGrossWeight, 0.10, 2, false)
      }))
    }

    const dimensionData = new DimensionPerKoliData({
      ...updatedData,
      totalPieces: updatedData.dimensionPieces.length,
      actualGrossWeight: updatedData.dimensionPieces.reduce(
        (total, item) => total + (item.sttPieceGrossWeight ? parseByCountry(item.sttPieceGrossWeight, { country: AccountController.accountData?.countryCode ?? "ID" }) : 0),
        0
      ),
      actualVolumeWeight: updatedData.dimensionPieces.reduce(
        (total, item) => total +
          (item.sttPieceVolumeWeight
            ? item.sttPieceVolumeWeight
            : 0
          ),
        0
      )
    });

    this.dimensionPerKoliData = dimensionData;
    storeDatatoSessionStorage("cargo-pieces-dimension", dimensionData);
  }

  @Mutation
  setDimensionPerKoliDataEdit(data: DimensionPerKoliData) {
    const updatedData = {
      ...data,
      dimensionPieces: data.dimensionPieces.map(piece => ({
        ...piece,
        sttPieceLength: Number(formatInputNoDecimal(String(piece.sttPieceLength))),
        sttPieceWidth: Number(formatInputNoDecimal(String(piece.sttPieceWidth))),
        sttPieceHeight: Number(formatInputNoDecimal(String(piece.sttPieceHeight))),
        sttPieceVolumeWeight: convertMinimumRounding(piece.sttPieceVolumeWeight, 1),
        sttPieceGrossWeight: convertMinimumRounding(piece.sttPieceGrossWeight, 0.10, 2, false)
      }))
    }
    const dimensionDataEdit = new DimensionPerKoliData({
      ...updatedData,
      totalPieces: updatedData.dimensionPieces.length,
      actualGrossWeight: updatedData.dimensionPieces.reduce(
        (total, item) => total + (item.sttPieceGrossWeight ? parseByCountry(item.sttPieceGrossWeight, { country: AccountController.accountData?.countryCode ?? "ID" }) : 0),
        0
      ),
      actualVolumeWeight: updatedData.dimensionPieces.reduce(
        (total, item) => total +
          (item.sttPieceVolumeWeight
            ? item.sttPieceVolumeWeight
            : 0
          ),
        0
      )
    });

    this.dimensionPerKoliDataEdit = dimensionDataEdit;
  }

  @Mutation
  setIsDimensionSaved(value: boolean) {
    this.isDimensionSaved = value;
    storeDatatoSessionStorage("is-dimension-saved", value);
  }

  @Mutation
  setIsSttUpdated(value: boolean) {
    this.isSttUpdated = value;
    storeDatatoSessionStorage("is-stt-updated", value);
  }

  @Mutation
  setIsAwbValid(value: boolean) {
    this.isAwbValid = value;
    storeDatatoSessionStorage("is-awb-valid", value);
  }

  @Mutation
  public setDisableDelay(value: boolean) {
    this.disableDelay = value;
  }

  @Mutation
  public setAirportDestination(item: any) {
    this.form.airportDestination = item;
  }

  @Mutation
  public addScanFailedList(data: CargoScanFailed): void {
    const idx = this.scanFailedList.findIndex(
      (e) => e.sttNumber === data.sttNumber
    );

    if (data.success)
      return void (idx >= 0 && this.scanFailedList.splice(idx, 1));

    if (idx >= 0) this.scanFailedList.splice(idx, 1);

    this.scanFailedList.unshift(data);
    storeDatatoSessionStorage(data.storageKey, this.scanFailedList);
  }

  @Mutation
  public setScanFailedListFromStorage(key: string) {
    this.scanFailedList = JSON.parse(getDataSessionStorage(key) || "[]");
  }

  @Mutation
  public resetScanFailedList(): void {
    for (const value of Object.values(CargoStorageKey)) {
      storeDatatoSessionStorage(value, []);
    }

    this.scanFailedList = [];
  }

  @Mutation
  public setphotoProof(val: any, index: number) {
    this.form.photoProof[index] = val;
  }

  @Mutation
  public resetphotoProof() {
    this.form.photoProof = [];
  }
  @Mutation
  public setIsDimensionChanged(val: boolean) {
    this.isDimensionChanged = val;
  }

  @Mutation
  setDimension(payload: {
    totalVolumeWeights: number;
    totalSttPieces: number;
  }) {
    const isPlaneAuto = this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto";
    const minimumWeight = isPlaneAuto ? FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue(): 0;
    this.isDimensionChanged = false;
    const divider = getConfigDimensionDivider(this.form.cargoType);

    const volumeWeight = Math.max(minimumWeight, 1, payload.totalVolumeWeights);

    const totalVolumeWeight = Math.max(
      1,
      Math.round(volumeWeight)
    );

    const height = Number(
      Math.max(
        1,
        Math.floor(
          (totalVolumeWeight * divider) / (90 * 60 * Math.max(payload.totalSttPieces, 1))
        )
      )
    );
    const length = 90;
    const width = 60;
    this.form.actualTotalCargoVolumeWeight = String(totalVolumeWeight);

    this.cargoInputForm.dimension = new DimensionData({
      length: length,
      width: width,
      height: height
    });
    this.form.actualDimension.height = height;
    this.form.actualDimension.length = length;
    this.form.actualDimension.width = width;
    this.isErrorInputStepThree.dimension = !this.form.actualDimension.width || !this.form.actualDimension.length || !this.form.actualDimension.height;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  setDimensionHeight(payload: {
    totalVolumeWeights: number;
    totalSttPieces: number;
  }) {
    const isPlaneAuto = this.form.cargoType === "plane" && this.form.cargoTypeStatus === "auto";
    const minimumWeight = isPlaneAuto ? FlagsPermissionCargo.validation_3lc_cargo_minimum_weight.getValue(): 0;

    const volumeWeight = Math.max(1, minimumWeight, payload.totalVolumeWeights)

    this.isDimensionChanged = false;
    const divider = getConfigDimensionDivider(this.form.cargoType);
    const length = this.form.actualDimension.length;
    const width = this.form.actualDimension.width;
    const height = Number(
      Math.max(
        1,
        Math.floor(
          (volumeWeight * divider) /
            (length * width * Math.max(payload.totalSttPieces, 1))
        )
      )
    );
    this.cargoInputForm.dimension.height = height;
    this.form.actualDimension.height = height;
    this.form.actualTotalCargoVolumeWeight = Math.round(volumeWeight).toString();
    this.cargoInputForm.totalActualCargoVolumeWeight = Math.round(volumeWeight);
    this.isErrorInputStepThree.dimension = !this.form.actualDimension.width || !this.form.actualDimension.length || !this.form.actualDimension.height;
    storeDatatoSessionStorage("cargo-input-data", this.cargoInputForm);
  }

  @Mutation
  setIsFirstLandingEditRTC(bool: boolean) {
    this.isFirstLandingEditRTC = bool;
  }

  @Action 
  async getCargoMinimumWeightSummary() {

    const requestParams = new CargoMinimumWeightSummaryApiRequest({
      startDate: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      endDate: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hubIds: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : "",
      cargoType: "plane"
    });

    this.setLoadingCargoDispute(true)
    const presenter = container.resolve(CargoPresenter);

    return presenter
      .getCargoMinimumWeightSummary(requestParams)
      .then((res: any) => {
        if (requestParams.cargoType !== "plane") this.setCargoMinimumWeightSummary(new CargoMinimumWeightSummaryData())
        else this.setCargoMinimumWeightSummary(res)
        return res;
      })
      .catch((error: any) => {
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        this.setLoadingCargoDispute(false)
      })
  }

  @Action 
  async downloadMinimumVolume() {
    MainAppController.showLoading();

    const requestParams = {
      start_date: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      end_date: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hub_ids: this.hubIdsSelected.length
        ? this.hubIdsSelected.join(",")
        : "",
      cargo_type: this.advanceFilterData.type.value || "plane"
    };

    const presenter = container.resolve(CargoPresenter);
    presenter
      .downloadMinimumVolume(requestParams)
      .then((res) => {
        return {
          data: res,
          success: true
        };
      })
      .catch((error: any) => {
        MainAppController.showErrorMessage(
          parsingErrorResponse(error, "Download Gagal !", () => {
            MainAppController.closeErrorMessage();
          })
        );
        return {
          data: "",
          success: false
        };
      })
      .finally(() => {
        MainAppController.closeLoading()
      });
  }

  @Action
  public async getCargoSummaryInProcess() {
    const accountOrigin = AccountController.accountData.account_location.city_code;
    const requestParams = new CargoSummaryInProcessRequest({
      originCity: this.advanceFilterData.cityOriginCode
        ? this.advanceFilterData.cityOriginCode
        : accountOrigin,
      destinationCity: this.advanceFilterData.cityDestinationCode,
      destinationAirport: this.advanceFilterData.airport,
      startDate: this.periodeStart
        ? new Date(this.periodeStart).toLocaleDateString("fr-CA")
        : new Date(new Date(new Date().setDate(new Date().getDate() - 1))).toLocaleDateString("fr-CA"),
      endDate: this.periodeEnd
        ? new Date(this.periodeEnd).toLocaleDateString("fr-CA")
        : new Date().toLocaleDateString("fr-CA"),
      hubIds: this.hubIdsSelected.length === 1 ? this.hubIdsSelected[0].toString() 
              :this.hubIdsSelected.length > 1 ? this.hubIdsSelected.join(",") : "",
    })

    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getSummaryInProcess(requestParams)
      .then((res: CargoSummaryInProcessData) => {
        this.setSummaryInProcess(res)
      })
      .catch((error: any) => {
        console.error("error fetch cargo summary: ", error)
      })
  }

  @Mutation 
  public setSummaryInProcess(value: CargoSummaryInProcessData) {
    this.summaryInProcessValue = value
  }

  @Action
  public async getCargoFailedUnread(params: FailedUnreadRequest) {
    const presenter = container.resolve(CargoPresenter);
    return presenter
      .getCargoFailedUnread(params)
      .then((res: CargoFailedUnread) => {
        this.setCargoFailedUnreadData(res);
      });
  }

  @Mutation
  public setCargoFailedUnreadData(data: CargoFailedUnread) {
    this.cargoFailedUnreadData = data;
  }

  @Action
  public async checkEligible(params: RequestCheckEligibleReadyToCargo) {
    const presenter = container.resolve(CargoPresenter);
    return presenter.checkEligible(params)
  }

  @Mutation
  public setItemToDelete(item: CargoDetailStt) {
    this.itemToDelete = item;
  }

  // error dispute
  get totalSttOutsideBag(): number {
    return this.sttResultFinal.filter(
      (item: CargoDetailStt) => !item.baggingNumber
    ).length;
  }
  get maxDisputeWeight(): number {
    const whitelist: number[] = FlagsPermissionCargoV2.config_whitelist_client_max_dispute_weight.getValue() as number[];
    const hasWhitelisted = this.sttResultFinal.some((item: CargoDetailStt) => {
      // if scan by stt there is no sttDetails
      if (!(item as any)?.sttDetails?.length) {
        return whitelist.includes(item.sttClientId);
      }

      // if scan by bag there is sttDetails
      return (item as any)?.sttDetails?.some((e: CargoDetailStt) =>
        whitelist.includes(e.sttClientId)
      );
    });

    return hasWhitelisted
      ? 0
      : FlagsPermissionCargoV2.config_max_dispute_weight.getValue();
  }
  get isExceedMaxDisputeWeight(): boolean {
    return this.calculateVolumeData.isMaximumDisputeWeight;
  }
  get isBagOnlyExceedMaxDisputeWeight() {
    return Boolean(
      this.calculateVolumeData.isMaximumDisputeWeight &&
        this.sttResultFinal.length &&
        !this.totalSttOutsideBag
    );
  }
}

export const CargoController = getModule(CargoStore);
